/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/@shopify/theme-cart/request.js":
/*!*****************************************************!*\
  !*** ./node_modules/@shopify/theme-cart/request.js ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cart": () => (/* binding */ cart),
/* harmony export */   "cartAdd": () => (/* binding */ cartAdd),
/* harmony export */   "cartAddFromForm": () => (/* binding */ cartAddFromForm),
/* harmony export */   "cartChange": () => (/* binding */ cartChange),
/* harmony export */   "cartClear": () => (/* binding */ cartClear),
/* harmony export */   "cartUpdate": () => (/* binding */ cartUpdate),
/* harmony export */   "cartShippingRates": () => (/* binding */ cartShippingRates)
/* harmony export */ });
function getDefaultRequestConfig() {
  return JSON.parse(
    JSON.stringify({
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;'
      }
    })
  );
}

function fetchJSON(url, config) {
  return fetch(url, config).then(function(response) {
    if (!response.ok) {
      throw response;
    }
    return response.json();
  });
}

function cart() {
  return fetchJSON('/cart.js', getDefaultRequestConfig());
}

function cartAdd(id, quantity, properties) {
  var config = getDefaultRequestConfig();

  config.method = 'POST';
  config.body = JSON.stringify({
    id: id,
    quantity: quantity,
    properties: properties
  });

  return fetchJSON('/cart/add.js', config);
}

function cartAddFromForm(formData) {
  var config = getDefaultRequestConfig();
  delete config.headers['Content-Type'];

  config.method = 'POST';
  config.body = formData;

  return fetchJSON('/cart/add.js', config);
}

function cartChange(line, options) {
  var config = getDefaultRequestConfig();

  options = options || {};

  config.method = 'POST';
  config.body = JSON.stringify({
    line: line,
    quantity: options.quantity,
    properties: options.properties
  });

  return fetchJSON('/cart/change.js', config);
}

function cartClear() {
  var config = getDefaultRequestConfig();
  config.method = 'POST';

  return fetchJSON('/cart/clear.js', config);
}

function cartUpdate(body) {
  var config = getDefaultRequestConfig();

  config.method = 'POST';
  config.body = JSON.stringify(body);

  return fetchJSON('/cart/update.js', config);
}

function cartShippingRates() {
  return fetchJSON('/cart/shipping_rates.json', getDefaultRequestConfig());
}


/***/ }),

/***/ "./node_modules/@shopify/theme-cart/theme-cart.js":
/*!********************************************************!*\
  !*** ./node_modules/@shopify/theme-cart/theme-cart.js ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getState": () => (/* binding */ getState),
/* harmony export */   "getItemIndex": () => (/* binding */ getItemIndex),
/* harmony export */   "getItem": () => (/* binding */ getItem),
/* harmony export */   "addItem": () => (/* binding */ addItem),
/* harmony export */   "addItemFromForm": () => (/* binding */ addItemFromForm),
/* harmony export */   "updateItem": () => (/* binding */ updateItem),
/* harmony export */   "removeItem": () => (/* binding */ removeItem),
/* harmony export */   "clearItems": () => (/* binding */ clearItems),
/* harmony export */   "getAttributes": () => (/* binding */ getAttributes),
/* harmony export */   "updateAttributes": () => (/* binding */ updateAttributes),
/* harmony export */   "clearAttributes": () => (/* binding */ clearAttributes),
/* harmony export */   "getNote": () => (/* binding */ getNote),
/* harmony export */   "updateNote": () => (/* binding */ updateNote),
/* harmony export */   "clearNote": () => (/* binding */ clearNote),
/* harmony export */   "getShippingRates": () => (/* binding */ getShippingRates)
/* harmony export */ });
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./request */ "./node_modules/@shopify/theme-cart/request.js");
/* harmony import */ var _validate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./validate */ "./node_modules/@shopify/theme-cart/validate.js");
/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */




/**
 * Returns the state object of the cart
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */
function getState() {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cart();
}

/**
 * Returns the index of the cart line item
 * @param {string} key The unique key of the line item
 * @returns {Promise} Resolves with the index number of the line item
 */
function getItemIndex(key) {
  _validate__WEBPACK_IMPORTED_MODULE_1__.key(key);

  return _request__WEBPACK_IMPORTED_MODULE_0__.cart().then(function(state) {
    var index = -1;

    state.items.forEach(function(item, i) {
      index = item.key === key ? i + 1 : index;
    });

    if (index === -1) {
      return Promise.reject(
        new Error('Theme Cart: Unable to match line item with provided key')
      );
    }

    return index;
  });
}

/**
 * Fetches the line item object
 * @param {string} key The unique key of the line item
 * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
 */
function getItem(key) {
  _validate__WEBPACK_IMPORTED_MODULE_1__.key(key);

  return _request__WEBPACK_IMPORTED_MODULE_0__.cart().then(function(state) {
    var lineItem = null;

    state.items.forEach(function(item) {
      lineItem = item.key === key ? item : lineItem;
    });

    if (lineItem === null) {
      return Promise.reject(
        new Error('Theme Cart: Unable to match line item with provided key')
      );
    }

    return lineItem;
  });
}

/**
 * Add a new line item to the cart
 * @param {number} id The variant's unique ID
 * @param {object} options Optional values to pass to /cart/add.js
 * @param {number} options.quantity The quantity of items to be added to the cart
 * @param {object} options.properties Line item property key/values (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-properties)
 * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
 */
function addItem(id, options) {
  options = options || {};

  _validate__WEBPACK_IMPORTED_MODULE_1__.id(id);

  return _request__WEBPACK_IMPORTED_MODULE_0__.cartAdd(id, options.quantity, options.properties);
}

/**
 * Add a new line item to the cart from a product form
 * @param {object} form DOM element which is equal to the <form> node
 * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
 */
function addItemFromForm(form) {
  _validate__WEBPACK_IMPORTED_MODULE_1__.form(form);

  var formData = new FormData(form);
  _validate__WEBPACK_IMPORTED_MODULE_1__.id(parseInt(formData.get('id'), 10));

  return _request__WEBPACK_IMPORTED_MODULE_0__.cartAddFromForm(formData);
}

/**
 * Changes the quantity and/or properties of an existing line item.
 * @param {string} key The unique key of the line item (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-key)
 * @param {object} options Optional values to pass to /cart/add.js
 * @param {number} options.quantity The quantity of items to be added to the cart
 * @param {object} options.properties Line item property key/values (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-properties)
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */
function updateItem(key, options) {
  _validate__WEBPACK_IMPORTED_MODULE_1__.key(key);
  _validate__WEBPACK_IMPORTED_MODULE_1__.options(options);

  return getItemIndex(key).then(function(line) {
    return _request__WEBPACK_IMPORTED_MODULE_0__.cartChange(line, options);
  });
}

/**
 * Removes a line item from the cart
 * @param {string} key The unique key of the line item (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-key)
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */
function removeItem(key) {
  _validate__WEBPACK_IMPORTED_MODULE_1__.key(key);

  return getItemIndex(key).then(function(line) {
    return _request__WEBPACK_IMPORTED_MODULE_0__.cartChange(line, { quantity: 0 });
  });
}

/**
 * Sets all quantities of all line items in the cart to zero. This does not remove cart attributes nor the cart note.
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */
function clearItems() {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cartClear();
}

/**
 * Gets all cart attributes
 * @returns {Promise} Resolves with the cart attributes object
 */
function getAttributes() {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cart().then(function(state) {
    return state.attributes;
  });
}

/**
 * Sets all cart attributes
 * @returns {Promise} Resolves with the cart state object
 */
function updateAttributes(attributes) {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cartUpdate({ attributes: attributes });
}

/**
 * Clears all cart attributes
 * @returns {Promise} Resolves with the cart state object
 */
function clearAttributes() {
  return getAttributes().then(function(attributes) {
    for (var key in attributes) {
      attributes[key] = '';
    }
    return updateAttributes(attributes);
  });
}

/**
 * Gets cart note
 * @returns {Promise} Resolves with the cart note string
 */
function getNote() {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cart().then(function(state) {
    return state.note;
  });
}

/**
 * Sets cart note
 * @returns {Promise} Resolves with the cart state object
 */
function updateNote(note) {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cartUpdate({ note: note });
}

/**
 * Clears cart note
 * @returns {Promise} Resolves with the cart state object
 */
function clearNote() {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cartUpdate({ note: '' });
}

/**
 * Get estimated shipping rates.
 * @returns {Promise} Resolves with response of /cart/shipping_rates.json (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-shipping-rates)
 */
function getShippingRates() {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cartShippingRates();
}


/***/ }),

/***/ "./node_modules/@shopify/theme-cart/validate.js":
/*!******************************************************!*\
  !*** ./node_modules/@shopify/theme-cart/validate.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "key": () => (/* binding */ key),
/* harmony export */   "quantity": () => (/* binding */ quantity),
/* harmony export */   "id": () => (/* binding */ id),
/* harmony export */   "properties": () => (/* binding */ properties),
/* harmony export */   "form": () => (/* binding */ form),
/* harmony export */   "options": () => (/* binding */ options)
/* harmony export */ });
function key(key) {
  if (typeof key !== 'string' || key.split(':').length !== 2) {
    throw new TypeError(
      'Theme Cart: Provided key value is not a string with the format xxx:xxx'
    );
  }
}

function quantity(quantity) {
  if (typeof quantity !== 'number' || isNaN(quantity)) {
    throw new TypeError(
      'Theme Cart: An object which specifies a quantity or properties value is required'
    );
  }
}

function id(id) {
  if (typeof id !== 'number' || isNaN(id)) {
    throw new TypeError('Theme Cart: Variant ID must be a number');
  }
}

function properties(properties) {
  if (typeof properties !== 'object') {
    throw new TypeError('Theme Cart: Properties must be an object');
  }
}

function form(form) {
  if (!(form instanceof HTMLFormElement)) {
    throw new TypeError('Theme Cart: Form must be an instance of HTMLFormElement');
  }
}

function options(options) {
  if (typeof options !== 'object') {
    throw new TypeError('Theme Cart: Options must be an object');
  }

  if (
    typeof options.quantity === 'undefined' &&
    typeof options.properties === 'undefined'
  ) {
    throw new Error(
      'Theme Cart: You muse define a value for quantity or properties'
    );
  }

  if (typeof options.quantity !== 'undefined') {
    quantity(options.quantity);
  }

  if (typeof options.properties !== 'undefined') {
    properties(options.properties);
  }
}


/***/ }),

/***/ "./node_modules/@shopify/theme-product-form/listeners.js":
/*!***************************************************************!*\
  !*** ./node_modules/@shopify/theme-product-form/listeners.js ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Listeners)
/* harmony export */ });
function Listeners() {
  this.entries = [];
}

Listeners.prototype.add = function(element, event, fn) {
  this.entries.push({ element: element, event: event, fn: fn });
  element.addEventListener(event, fn);
};

Listeners.prototype.removeAll = function() {
  this.entries = this.entries.filter(function(listener) {
    listener.element.removeEventListener(listener.event, listener.fn);
    return false;
  });
};


/***/ }),

/***/ "./node_modules/@shopify/theme-product-form/theme-product-form.js":
/*!************************************************************************!*\
  !*** ./node_modules/@shopify/theme-product-form/theme-product-form.js ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getUrlWithVariant": () => (/* binding */ getUrlWithVariant),
/* harmony export */   "ProductForm": () => (/* binding */ ProductForm)
/* harmony export */ });
/* harmony import */ var _listeners__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./listeners */ "./node_modules/@shopify/theme-product-form/listeners.js");
/* harmony import */ var _shopify_theme_product__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @shopify/theme-product */ "./node_modules/@shopify/theme-product/theme-product.js");



var selectors = {
  idInput: '[name="id"]',
  optionInput: '[name^="options"]',
  quantityInput: '[name="quantity"]',
  propertyInput: '[name^="properties"]'
};

// Public Methods
// -----------------------------------------------------------------------------

/**
 * Returns a URL with a variant ID query parameter. Useful for updating window.history
 * with a new URL based on the currently select product variant.
 * @param {string} url - The URL you wish to append the variant ID to
 * @param {number} id  - The variant ID you wish to append to the URL
 * @returns {string} - The new url which includes the variant ID query parameter
 */

function getUrlWithVariant(url, id) {
  if (/variant=/.test(url)) {
    return url.replace(/(variant=)[^&]+/, '$1' + id);
  } else if (/\?/.test(url)) {
    return url.concat('&variant=').concat(id);
  }

  return url.concat('?variant=').concat(id);
}

/**
 * Constructor class that creates a new instance of a product form controller.
 *
 * @param {Element} element - DOM element which is equal to the <form> node wrapping product form inputs
 * @param {Object} product - A product object
 * @param {Object} options - Optional options object
 * @param {Function} options.onOptionChange - Callback for whenever an option input changes
 * @param {Function} options.onQuantityChange - Callback for whenever an quantity input changes
 * @param {Function} options.onPropertyChange - Callback for whenever a property input changes
 * @param {Function} options.onFormSubmit - Callback for whenever the product form is submitted
 */
function ProductForm(element, product, options) {
  this.element = element;
  this.product = _validateProductObject(product);

  options = options || {};

  this._listeners = new _listeners__WEBPACK_IMPORTED_MODULE_0__["default"]();
  this._listeners.add(
    this.element,
    'submit',
    this._onSubmit.bind(this, options)
  );

  this.optionInputs = this._initInputs(
    selectors.optionInput,
    options.onOptionChange
  );

  this.quantityInputs = this._initInputs(
    selectors.quantityInput,
    options.onQuantityChange
  );

  this.propertyInputs = this._initInputs(
    selectors.propertyInput,
    options.onPropertyChange
  );
}

/**
 * Cleans up all event handlers that were assigned when the Product Form was constructed.
 * Useful for use when a section needs to be reloaded in the theme editor.
 */
ProductForm.prototype.destroy = function() {
  this._listeners.removeAll();
};

/**
 * Getter method which returns the array of currently selected option values
 *
 * @returns {Array} An array of option values
 */
ProductForm.prototype.options = function() {
  return _serializeOptionValues(this.optionInputs, function(item) {
    var regex = /(?:^(options\[))(.*?)(?:\])/;
    item.name = regex.exec(item.name)[2]; // Use just the value between 'options[' and ']'
    return item;
  });
};

/**
 * Getter method which returns the currently selected variant, or `null` if variant
 * doesn't exist.
 *
 * @returns {Object|null} Variant object
 */
ProductForm.prototype.variant = function() {
  return (0,_shopify_theme_product__WEBPACK_IMPORTED_MODULE_1__.getVariantFromSerializedArray)(this.product, this.options());
};

/**
 * Getter method which returns a collection of objects containing name and values
 * of property inputs
 *
 * @returns {Array} Collection of objects with name and value keys
 */
ProductForm.prototype.properties = function() {
  var properties = _serializePropertyValues(this.propertyInputs, function(
    propertyName
  ) {
    var regex = /(?:^(properties\[))(.*?)(?:\])/;
    var name = regex.exec(propertyName)[2]; // Use just the value between 'properties[' and ']'
    return name;
  });

  return Object.entries(properties).length === 0 ? null : properties;
};

/**
 * Getter method which returns the current quantity or 1 if no quantity input is
 * included in the form
 *
 * @returns {Array} Collection of objects with name and value keys
 */
ProductForm.prototype.quantity = function() {
  return this.quantityInputs[0]
    ? Number.parseInt(this.quantityInputs[0].value, 10)
    : 1;
};

// Private Methods
// -----------------------------------------------------------------------------
ProductForm.prototype._setIdInputValue = function(value) {
  var idInputElement = this.element.querySelector(selectors.idInput);

  if (!idInputElement) {
    idInputElement = document.createElement('input');
    idInputElement.type = 'hidden';
    idInputElement.name = 'id';
    this.element.appendChild(idInputElement);
  }

  idInputElement.value = value.toString();
};

ProductForm.prototype._onSubmit = function(options, event) {
  event.dataset = this._getProductFormEventData();

  if (event.dataset.variant) {
    this._setIdInputValue(event.dataset.variant.id);
  }

  if (options.onFormSubmit) {
    options.onFormSubmit(event);
  }
};

ProductForm.prototype._onFormEvent = function(cb) {
  if (typeof cb === 'undefined') {
    return Function.prototype;
  }

  return function(event) {
    event.dataset = this._getProductFormEventData();
    cb(event);
  }.bind(this);
};

ProductForm.prototype._initInputs = function(selector, cb) {
  var elements = Array.prototype.slice.call(
    this.element.querySelectorAll(selector)
  );

  return elements.map(
    function(element) {
      this._listeners.add(element, 'change', this._onFormEvent(cb));
      return element;
    }.bind(this)
  );
};

ProductForm.prototype._getProductFormEventData = function() {
  return {
    options: this.options(),
    variant: this.variant(),
    properties: this.properties(),
    quantity: this.quantity()
  };
};

function _serializeOptionValues(inputs, transform) {
  return inputs.reduce(function(options, input) {
    if (
      input.checked || // If input is a checked (means type radio or checkbox)
      (input.type !== 'radio' && input.type !== 'checkbox') // Or if its any other type of input
    ) {
      options.push(transform({ name: input.name, value: input.value }));
    }

    return options;
  }, []);
}

function _serializePropertyValues(inputs, transform) {
  return inputs.reduce(function(properties, input) {
    if (
      input.checked || // If input is a checked (means type radio or checkbox)
      (input.type !== 'radio' && input.type !== 'checkbox') // Or if its any other type of input
    ) {
      properties[transform(input.name)] = input.value;
    }

    return properties;
  }, {});
}

function _validateProductObject(product) {
  if (typeof product !== 'object') {
    throw new TypeError(product + ' is not an object.');
  }

  if (typeof product.variants[0].options === 'undefined') {
    throw new TypeError(
      'Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route'
    );
  }

  return product;
}


/***/ }),

/***/ "./node_modules/@shopify/theme-product/theme-product.js":
/*!**************************************************************!*\
  !*** ./node_modules/@shopify/theme-product/theme-product.js ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getProductJson": () => (/* binding */ getProductJson),
/* harmony export */   "getVariantFromId": () => (/* binding */ getVariantFromId),
/* harmony export */   "getVariantFromSerializedArray": () => (/* binding */ getVariantFromSerializedArray),
/* harmony export */   "getVariantFromOptionArray": () => (/* binding */ getVariantFromOptionArray)
/* harmony export */ });
/**
 * Returns a product JSON object when passed a product URL
 * @param {*} url
 */
function getProductJson(handle) {
  return fetch('/products/' + handle + '.js').then(function(response) {
    return response.json();
  });
}

/**
 * Find a match in the project JSON (using a ID number) and return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Number} value Accepts Number (e.g. 6908023078973)
 * @returns {Object} The variant object once a match has been successful. Otherwise null will be return
 */
function getVariantFromId(product, value) {
  _validateProductStructure(product);

  if (typeof value !== 'number') {
    throw new TypeError(value + ' is not a Number.');
  }

  var result = product.variants.filter(function(variant) {
    return variant.id === value;
  });

  return result[0] || null;
}

/**
 * Convert the Object (with 'name' and 'value' keys) into an Array of values, then find a match & return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Object} collection Object with 'name' and 'value' keys (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
 * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
 */
function getVariantFromSerializedArray(product, collection) {
  _validateProductStructure(product);

  // If value is an array of options
  var optionArray = _createOptionArrayFromOptionCollection(product, collection);
  return getVariantFromOptionArray(product, optionArray);
}

/**
 * Find a match in the project JSON (using Array with option values) and return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Array} options List of submitted values (e.g. ['36', 'Black'])
 * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
 */
function getVariantFromOptionArray(product, options) {
  _validateProductStructure(product);
  _validateOptionsArray(options);

  var result = product.variants.filter(function(variant) {
    return options.every(function(option, index) {
      return variant.options[index] === option;
    });
  });

  return result[0] || null;
}

/**
 * Creates an array of selected options from the object
 * Loops through the project.options and check if the "option name" exist (product.options.name) and matches the target
 * @param {Object} product Product JSON object
 * @param {Array} collection Array of object (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
 * @returns {Array} The result of the matched values. (e.g. ['36', 'Black'])
 */
function _createOptionArrayFromOptionCollection(product, collection) {
  _validateProductStructure(product);
  _validateSerializedArray(collection);

  var optionArray = [];

  collection.forEach(function(option) {
    for (var i = 0; i < product.options.length; i++) {
      if (product.options[i].name.toLowerCase() === option.name.toLowerCase()) {
        optionArray[i] = option.value;
        break;
      }
    }
  });

  return optionArray;
}

/**
 * Check if the product data is a valid JS object
 * Error will be thrown if type is invalid
 * @param {object} product Product JSON object
 */
function _validateProductStructure(product) {
  if (typeof product !== 'object') {
    throw new TypeError(product + ' is not an object.');
  }

  if (Object.keys(product).length === 0 && product.constructor === Object) {
    throw new Error(product + ' is empty.');
  }
}

/**
 * Validate the structure of the array
 * It must be formatted like jQuery's serializeArray()
 * @param {Array} collection Array of object [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }]
 */
function _validateSerializedArray(collection) {
  if (!Array.isArray(collection)) {
    throw new TypeError(collection + ' is not an array.');
  }

  if (collection.length === 0) {
    return [];
  }

  if (collection[0].hasOwnProperty('name')) {
    if (typeof collection[0].name !== 'string') {
      throw new TypeError(
        'Invalid value type passed for name of option ' +
          collection[0].name +
          '. Value should be string.'
      );
    }
  } else {
    throw new Error(collection[0] + 'does not contain name key.');
  }
}

/**
 * Validate the structure of the array
 * It must be formatted as list of values
 * @param {Array} collection Array of object (e.g. ['36', 'Black'])
 */
function _validateOptionsArray(options) {
  if (Array.isArray(options) && typeof options[0] === 'object') {
    throw new Error(options + 'is not a valid array of options.');
  }
}


/***/ }),

/***/ "./node_modules/@shopify/theme-sections/section.js":
/*!*********************************************************!*\
  !*** ./node_modules/@shopify/theme-sections/section.js ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Section)
/* harmony export */ });
var SECTION_ID_ATTR = 'data-section-id';

function Section(container, properties) {
  this.container = validateContainerElement(container);
  this.id = container.getAttribute(SECTION_ID_ATTR);
  this.extensions = [];

  // eslint-disable-next-line es5/no-es6-static-methods
  Object.assign(this, validatePropertiesObject(properties));

  this.onLoad();
}

Section.prototype = {
  onLoad: Function.prototype,
  onUnload: Function.prototype,
  onSelect: Function.prototype,
  onDeselect: Function.prototype,
  onBlockSelect: Function.prototype,
  onBlockDeselect: Function.prototype,

  extend: function extend(extension) {
    this.extensions.push(extension); // Save original extension

    // eslint-disable-next-line es5/no-es6-static-methods
    var extensionClone = Object.assign({}, extension);
    delete extensionClone.init; // Remove init function before assigning extension properties

    // eslint-disable-next-line es5/no-es6-static-methods
    Object.assign(this, extensionClone);

    if (typeof extension.init === 'function') {
      extension.init.apply(this);
    }
  }
};

function validateContainerElement(container) {
  if (!(container instanceof Element)) {
    throw new TypeError(
      'Theme Sections: Attempted to load section. The section container provided is not a DOM element.'
    );
  }
  if (container.getAttribute(SECTION_ID_ATTR) === null) {
    throw new Error(
      'Theme Sections: The section container provided does not have an id assigned to the ' +
        SECTION_ID_ATTR +
        ' attribute.'
    );
  }

  return container;
}

function validatePropertiesObject(value) {
  if (
    (typeof value !== 'undefined' && typeof value !== 'object') ||
    value === null
  ) {
    throw new TypeError(
      'Theme Sections: The properties object provided is not a valid'
    );
  }

  return value;
}

// Object.assign() polyfill from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
if (typeof Object.assign != 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, 'assign', {
    value: function assign(target) {
      // .length of function is 2
      'use strict';
      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) {
          // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}


/***/ }),

/***/ "./node_modules/@shopify/theme-sections/theme-sections.js":
/*!****************************************************************!*\
  !*** ./node_modules/@shopify/theme-sections/theme-sections.js ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "registered": () => (/* binding */ registered),
/* harmony export */   "instances": () => (/* binding */ instances),
/* harmony export */   "register": () => (/* binding */ register),
/* harmony export */   "unregister": () => (/* binding */ unregister),
/* harmony export */   "load": () => (/* binding */ load),
/* harmony export */   "unload": () => (/* binding */ unload),
/* harmony export */   "extend": () => (/* binding */ extend),
/* harmony export */   "getInstances": () => (/* binding */ getInstances),
/* harmony export */   "getInstanceById": () => (/* binding */ getInstanceById),
/* harmony export */   "isInstance": () => (/* binding */ isInstance)
/* harmony export */ });
/* harmony import */ var _section__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./section */ "./node_modules/@shopify/theme-sections/section.js");
/*
 * @shopify/theme-sections
 * -----------------------------------------------------------------------------
 *
 * A framework to provide structure to your Shopify sections and a load and unload
 * lifecycle. The lifecycle is automatically connected to theme editor events so
 * that your sections load and unload as the editor changes the content and
 * settings of your sections.
 */



var SECTION_TYPE_ATTR = 'data-section-type';
var SECTION_ID_ATTR = 'data-section-id';

window.Shopify = window.Shopify || {};
window.Shopify.theme = window.Shopify.theme || {};
window.Shopify.theme.sections = window.Shopify.theme.sections || {};

var registered = (window.Shopify.theme.sections.registered =
  window.Shopify.theme.sections.registered || {});
var instances = (window.Shopify.theme.sections.instances =
  window.Shopify.theme.sections.instances || []);

function register(type, properties) {
  if (typeof type !== 'string') {
    throw new TypeError(
      'Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered'
    );
  }

  if (typeof registered[type] !== 'undefined') {
    throw new Error(
      'Theme Sections: A section of type "' +
        type +
        '" has already been registered. You cannot register the same section type twice'
    );
  }

  function TypedSection(container) {
    _section__WEBPACK_IMPORTED_MODULE_0__["default"].call(this, container, properties);
  }

  TypedSection.constructor = _section__WEBPACK_IMPORTED_MODULE_0__["default"];
  TypedSection.prototype = Object.create(_section__WEBPACK_IMPORTED_MODULE_0__["default"].prototype);
  TypedSection.prototype.type = type;

  return (registered[type] = TypedSection);
}

function unregister(types) {
  types = normalizeType(types);

  types.forEach(function(type) {
    delete registered[type];
  });
}

function load(types, containers) {
  types = normalizeType(types);

  if (typeof containers === 'undefined') {
    containers = document.querySelectorAll('[' + SECTION_TYPE_ATTR + ']');
  }

  containers = normalizeContainers(containers);

  types.forEach(function(type) {
    var TypedSection = registered[type];

    if (typeof TypedSection === 'undefined') {
      return;
    }

    containers = containers.filter(function(container) {
      // Filter from list of containers because container already has an instance loaded
      if (isInstance(container)) {
        return false;
      }

      // Filter from list of containers because container doesn't have data-section-type attribute
      if (container.getAttribute(SECTION_TYPE_ATTR) === null) {
        return false;
      }

      // Keep in list of containers because current type doesn't match
      if (container.getAttribute(SECTION_TYPE_ATTR) !== type) {
        return true;
      }

      instances.push(new TypedSection(container));

      // Filter from list of containers because container now has an instance loaded
      return false;
    });
  });
}

function unload(selector) {
  var instancesToUnload = getInstances(selector);

  instancesToUnload.forEach(function(instance) {
    var index = instances
      .map(function(e) {
        return e.id;
      })
      .indexOf(instance.id);
    instances.splice(index, 1);
    instance.onUnload();
  });
}

function extend(selector, extension) {
  var instancesToExtend = getInstances(selector);

  instancesToExtend.forEach(function(instance) {
    instance.extend(extension);
  });
}

function getInstances(selector) {
  var filteredInstances = [];

  // Fetch first element if its an array
  if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) {
    var firstElement = selector[0];
  }

  // If selector element is DOM element
  if (selector instanceof Element || firstElement instanceof Element) {
    var containers = normalizeContainers(selector);

    containers.forEach(function(container) {
      filteredInstances = filteredInstances.concat(
        instances.filter(function(instance) {
          return instance.container === container;
        })
      );
    });

    // If select is type string
  } else if (typeof selector === 'string' || typeof firstElement === 'string') {
    var types = normalizeType(selector);

    types.forEach(function(type) {
      filteredInstances = filteredInstances.concat(
        instances.filter(function(instance) {
          return instance.type === type;
        })
      );
    });
  }

  return filteredInstances;
}

function getInstanceById(id) {
  var instance;

  for (var i = 0; i < instances.length; i++) {
    if (instances[i].id === id) {
      instance = instances[i];
      break;
    }
  }
  return instance;
}

function isInstance(selector) {
  return getInstances(selector).length > 0;
}

function normalizeType(types) {
  // If '*' then fetch all registered section types
  if (types === '*') {
    types = Object.keys(registered);

    // If a single section type string is passed, put it in an array
  } else if (typeof types === 'string') {
    types = [types];

    // If single section constructor is passed, transform to array with section
    // type string
  } else if (types.constructor === _section__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    types = [types.prototype.type];

    // If array of typed section constructors is passed, transform the array to
    // type strings
  } else if (Array.isArray(types) && types[0].constructor === _section__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    types = types.map(function(TypedSection) {
      return TypedSection.prototype.type;
    });
  }

  types = types.map(function(type) {
    return type.toLowerCase();
  });

  return types;
}

function normalizeContainers(containers) {
  // Nodelist with entries
  if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) {
    containers = Array.prototype.slice.call(containers);

    // Empty Nodelist
  } else if (
    NodeList.prototype.isPrototypeOf(containers) &&
    containers.length === 0
  ) {
    containers = [];

    // Handle null (document.querySelector() returns null with no match)
  } else if (containers === null) {
    containers = [];

    // Single DOM element
  } else if (!Array.isArray(containers) && containers instanceof Element) {
    containers = [containers];
  }

  return containers;
}

if (window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    var id = event.detail.sectionId;
    var container = event.target.querySelector(
      '[' + SECTION_ID_ATTR + '="' + id + '"]'
    );

    if (container !== null) {
      load(container.getAttribute(SECTION_TYPE_ATTR), container);
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    var id = event.detail.sectionId;
    var container = event.target.querySelector(
      '[' + SECTION_ID_ATTR + '="' + id + '"]'
    );
    var instance = getInstances(container)[0];

    if (typeof instance === 'object') {
      unload(container);
    }
  });

  document.addEventListener('shopify:section:select', function(event) {
    var instance = getInstanceById(event.detail.sectionId);

    if (typeof instance === 'object') {
      instance.onSelect(event);
    }
  });

  document.addEventListener('shopify:section:deselect', function(event) {
    var instance = getInstanceById(event.detail.sectionId);

    if (typeof instance === 'object') {
      instance.onDeselect(event);
    }
  });

  document.addEventListener('shopify:block:select', function(event) {
    var instance = getInstanceById(event.detail.sectionId);

    if (typeof instance === 'object') {
      instance.onBlockSelect(event);
    }
  });

  document.addEventListener('shopify:block:deselect', function(event) {
    var instance = getInstanceById(event.detail.sectionId);

    if (typeof instance === 'object') {
      instance.onBlockDeselect(event);
    }
  });
}


/***/ }),

/***/ "./node_modules/lazysizes/lazysizes.js":
/*!*********************************************!*\
  !*** ./node_modules/lazysizes/lazysizes.js ***!
  \*********************************************/
/***/ ((module) => {

(function(window, factory) {
	var lazySizes = factory(window, window.document, Date);
	window.lazySizes = lazySizes;
	if( true && module.exports){
		module.exports = lazySizes;
	}
}(typeof window != 'undefined' ?
      window : {}, 
/**
 * import("./types/global")
 * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
 */
function l(window, document, Date) { // Pass in the window Date function also for SSR because the Date class can be lost
	'use strict';
	/*jshint eqnull:true */

	var lazysizes,
		/**
		 * @type { LazySizesConfigPartial }
		 */
		lazySizesCfg;

	(function(){
		var prop;

		var lazySizesDefaults = {
			lazyClass: 'lazyload',
			loadedClass: 'lazyloaded',
			loadingClass: 'lazyloading',
			preloadClass: 'lazypreload',
			errorClass: 'lazyerror',
			//strictClass: 'lazystrict',
			autosizesClass: 'lazyautosizes',
			fastLoadedClass: 'ls-is-cached',
			iframeLoadMode: 0,
			srcAttr: 'data-src',
			srcsetAttr: 'data-srcset',
			sizesAttr: 'data-sizes',
			//preloadAfterLoad: false,
			minSize: 40,
			customMedia: {},
			init: true,
			expFactor: 1.5,
			hFac: 0.8,
			loadMode: 2,
			loadHidden: true,
			ricTimeout: 0,
			throttleDelay: 125,
		};

		lazySizesCfg = window.lazySizesConfig || window.lazysizesConfig || {};

		for(prop in lazySizesDefaults){
			if(!(prop in lazySizesCfg)){
				lazySizesCfg[prop] = lazySizesDefaults[prop];
			}
		}
	})();

	if (!document || !document.getElementsByClassName) {
		return {
			init: function () {},
			/**
			 * @type { LazySizesConfigPartial }
			 */
			cfg: lazySizesCfg,
			/**
			 * @type { true }
			 */
			noSupport: true,
		};
	}

	var docElem = document.documentElement;

	var supportPicture = window.HTMLPictureElement;

	var _addEventListener = 'addEventListener';

	var _getAttribute = 'getAttribute';

	/**
	 * Update to bind to window because 'this' becomes null during SSR
	 * builds.
	 */
	var addEventListener = window[_addEventListener].bind(window);

	var setTimeout = window.setTimeout;

	var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

	var requestIdleCallback = window.requestIdleCallback;

	var regPicture = /^picture$/i;

	var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

	var regClassCache = {};

	var forEach = Array.prototype.forEach;

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var hasClass = function(ele, cls) {
		if(!regClassCache[cls]){
			regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
		}
		return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
	};

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var addClass = function(ele, cls) {
		if (!hasClass(ele, cls)){
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
		}
	};

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var removeClass = function(ele, cls) {
		var reg;
		if ((reg = hasClass(ele,cls))) {
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
		}
	};

	var addRemoveLoadEvents = function(dom, fn, add){
		var action = add ? _addEventListener : 'removeEventListener';
		if(add){
			addRemoveLoadEvents(dom, fn);
		}
		loadEvents.forEach(function(evt){
			dom[action](evt, fn);
		});
	};

	/**
	 * @param elem { Element }
	 * @param name { string }
	 * @param detail { any }
	 * @param noBubbles { boolean }
	 * @param noCancelable { boolean }
	 * @returns { CustomEvent }
	 */
	var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
		var event = document.createEvent('Event');

		if(!detail){
			detail = {};
		}

		detail.instance = lazysizes;

		event.initEvent(name, !noBubbles, !noCancelable);

		event.detail = detail;

		elem.dispatchEvent(event);
		return event;
	};

	var updatePolyfill = function (el, full){
		var polyfill;
		if( !supportPicture && ( polyfill = (window.picturefill || lazySizesCfg.pf) ) ){
			if(full && full.src && !el[_getAttribute]('srcset')){
				el.setAttribute('srcset', full.src);
			}
			polyfill({reevaluate: true, elements: [el]});
		} else if(full && full.src){
			el.src = full.src;
		}
	};

	var getCSS = function (elem, style){
		return (getComputedStyle(elem, null) || {})[style];
	};

	/**
	 *
	 * @param elem { Element }
	 * @param parent { Element }
	 * @param [width] {number}
	 * @returns {number}
	 */
	var getWidth = function(elem, parent, width){
		width = width || elem.offsetWidth;

		while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
			width =  parent.offsetWidth;
			parent = parent.parentNode;
		}

		return width;
	};

	var rAF = (function(){
		var running, waiting;
		var firstFns = [];
		var secondFns = [];
		var fns = firstFns;

		var run = function(){
			var runFns = fns;

			fns = firstFns.length ? secondFns : firstFns;

			running = true;
			waiting = false;

			while(runFns.length){
				runFns.shift()();
			}

			running = false;
		};

		var rafBatch = function(fn, queue){
			if(running && !queue){
				fn.apply(this, arguments);
			} else {
				fns.push(fn);

				if(!waiting){
					waiting = true;
					(document.hidden ? setTimeout : requestAnimationFrame)(run);
				}
			}
		};

		rafBatch._lsFlush = run;

		return rafBatch;
	})();

	var rAFIt = function(fn, simple){
		return simple ?
			function() {
				rAF(fn);
			} :
			function(){
				var that = this;
				var args = arguments;
				rAF(function(){
					fn.apply(that, args);
				});
			}
		;
	};

	var throttle = function(fn){
		var running;
		var lastTime = 0;
		var gDelay = lazySizesCfg.throttleDelay;
		var rICTimeout = lazySizesCfg.ricTimeout;
		var run = function(){
			running = false;
			lastTime = Date.now();
			fn();
		};
		var idleCallback = requestIdleCallback && rICTimeout > 49 ?
			function(){
				requestIdleCallback(run, {timeout: rICTimeout});

				if(rICTimeout !== lazySizesCfg.ricTimeout){
					rICTimeout = lazySizesCfg.ricTimeout;
				}
			} :
			rAFIt(function(){
				setTimeout(run);
			}, true)
		;

		return function(isPriority){
			var delay;

			if((isPriority = isPriority === true)){
				rICTimeout = 33;
			}

			if(running){
				return;
			}

			running =  true;

			delay = gDelay - (Date.now() - lastTime);

			if(delay < 0){
				delay = 0;
			}

			if(isPriority || delay < 9){
				idleCallback();
			} else {
				setTimeout(idleCallback, delay);
			}
		};
	};

	//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
	var debounce = function(func) {
		var timeout, timestamp;
		var wait = 99;
		var run = function(){
			timeout = null;
			func();
		};
		var later = function() {
			var last = Date.now() - timestamp;

			if (last < wait) {
				setTimeout(later, wait - last);
			} else {
				(requestIdleCallback || run)(run);
			}
		};

		return function() {
			timestamp = Date.now();

			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
		};
	};

	var loader = (function(){
		var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

		var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;

		var regImg = /^img$/i;
		var regIframe = /^iframe$/i;

		var supportScroll = ('onscroll' in window) && !(/(gle|ing)bot/.test(navigator.userAgent));

		var shrinkExpand = 0;
		var currentExpand = 0;

		var isLoading = 0;
		var lowRuns = -1;

		var resetPreloading = function(e){
			isLoading--;
			if(!e || isLoading < 0 || !e.target){
				isLoading = 0;
			}
		};

		var isVisible = function (elem) {
			if (isBodyHidden == null) {
				isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
			}

			return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
		};

		var isNestedVisible = function(elem, elemExpand){
			var outerRect;
			var parent = elem;
			var visible = isVisible(elem);

			eLtop -= elemExpand;
			eLbottom += elemExpand;
			eLleft -= elemExpand;
			eLright += elemExpand;

			while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
				visible = ((getCSS(parent, 'opacity') || 1) > 0);

				if(visible && getCSS(parent, 'overflow') != 'visible'){
					outerRect = parent.getBoundingClientRect();
					visible = eLright > outerRect.left &&
						eLleft < outerRect.right &&
						eLbottom > outerRect.top - 1 &&
						eLtop < outerRect.bottom + 1
					;
				}
			}

			return visible;
		};

		var checkElements = function() {
			var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal,
				beforeExpandVal, defaultExpand, preloadExpand, hFac;
			var lazyloadElems = lazysizes.elements;

			if((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){

				i = 0;

				lowRuns++;

				for(; i < eLlen; i++){

					if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}

					if(!supportScroll || (lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i]))){unveilElement(lazyloadElems[i]);continue;}

					if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
						elemExpand = currentExpand;
					}

					if (!defaultExpand) {
						defaultExpand = (!lazySizesCfg.expand || lazySizesCfg.expand < 1) ?
							docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 :
							lazySizesCfg.expand;

						lazysizes._defEx = defaultExpand;

						preloadExpand = defaultExpand * lazySizesCfg.expFactor;
						hFac = lazySizesCfg.hFac;
						isBodyHidden = null;

						if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
							currentExpand = preloadExpand;
							lowRuns = 0;
						} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
							currentExpand = defaultExpand;
						} else {
							currentExpand = shrinkExpand;
						}
					}

					if(beforeExpandVal !== elemExpand){
						eLvW = innerWidth + (elemExpand * hFac);
						elvH = innerHeight + elemExpand;
						elemNegativeExpand = elemExpand * -1;
						beforeExpandVal = elemExpand;
					}

					rect = lazyloadElems[i].getBoundingClientRect();

					if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
						(eLtop = rect.top) <= elvH &&
						(eLright = rect.right) >= elemNegativeExpand * hFac &&
						(eLleft = rect.left) <= eLvW &&
						(eLbottom || eLright || eLleft || eLtop) &&
						(lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) &&
						((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
						unveilElement(lazyloadElems[i]);
						loadedSomething = true;
						if(isLoading > 9){break;}
					} else if(!loadedSomething && isCompleted && !autoLoadElem &&
						isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
						(preloadElems[0] || lazySizesCfg.preloadAfterLoad) &&
						(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto')))){
						autoLoadElem = preloadElems[0] || lazyloadElems[i];
					}
				}

				if(autoLoadElem && !loadedSomething){
					unveilElement(autoLoadElem);
				}
			}
		};

		var throttledCheckElements = throttle(checkElements);

		var switchLoadingClass = function(e){
			var elem = e.target;

			if (elem._lazyCache) {
				delete elem._lazyCache;
				return;
			}

			resetPreloading(e);
			addClass(elem, lazySizesCfg.loadedClass);
			removeClass(elem, lazySizesCfg.loadingClass);
			addRemoveLoadEvents(elem, rafSwitchLoadingClass);
			triggerEvent(elem, 'lazyloaded');
		};
		var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
		var rafSwitchLoadingClass = function(e){
			rafedSwitchLoadingClass({target: e.target});
		};

		var changeIframeSrc = function(elem, src){
			var loadMode = elem.getAttribute('data-load-mode') || lazySizesCfg.iframeLoadMode;

			// loadMode can be also a string!
			if (loadMode == 0) {
				elem.contentWindow.location.replace(src);
			} else if (loadMode == 1) {
				elem.src = src;
			}
		};

		var handleSources = function(source){
			var customMedia;

			var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);

			if( (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
				source.setAttribute('media', customMedia);
			}

			if(sourceSrcset){
				source.setAttribute('srcset', sourceSrcset);
			}
		};

		var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
			var src, srcset, parent, isPicture, event, firesLoad;

			if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){

				if(sizes){
					if(isAuto){
						addClass(elem, lazySizesCfg.autosizesClass);
					} else {
						elem.setAttribute('sizes', sizes);
					}
				}

				srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
				src = elem[_getAttribute](lazySizesCfg.srcAttr);

				if(isImg) {
					parent = elem.parentNode;
					isPicture = parent && regPicture.test(parent.nodeName || '');
				}

				firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));

				event = {target: elem};

				addClass(elem, lazySizesCfg.loadingClass);

				if(firesLoad){
					clearTimeout(resetPreloadingTimer);
					resetPreloadingTimer = setTimeout(resetPreloading, 2500);
					addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
				}

				if(isPicture){
					forEach.call(parent.getElementsByTagName('source'), handleSources);
				}

				if(srcset){
					elem.setAttribute('srcset', srcset);
				} else if(src && !isPicture){
					if(regIframe.test(elem.nodeName)){
						changeIframeSrc(elem, src);
					} else {
						elem.src = src;
					}
				}

				if(isImg && (srcset || isPicture)){
					updatePolyfill(elem, {src: src});
				}
			}

			if(elem._lazyRace){
				delete elem._lazyRace;
			}
			removeClass(elem, lazySizesCfg.lazyClass);

			rAF(function(){
				// Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
				var isLoaded = elem.complete && elem.naturalWidth > 1;

				if( !firesLoad || isLoaded){
					if (isLoaded) {
						addClass(elem, lazySizesCfg.fastLoadedClass);
					}
					switchLoadingClass(event);
					elem._lazyCache = true;
					setTimeout(function(){
						if ('_lazyCache' in elem) {
							delete elem._lazyCache;
						}
					}, 9);
				}
				if (elem.loading == 'lazy') {
					isLoading--;
				}
			}, true);
		});

		/**
		 *
		 * @param elem { Element }
		 */
		var unveilElement = function (elem){
			if (elem._lazyRace) {return;}
			var detail;

			var isImg = regImg.test(elem.nodeName);

			//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
			var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
			var isAuto = sizes == 'auto';

			if( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)){return;}

			detail = triggerEvent(elem, 'lazyunveilread').detail;

			if(isAuto){
				 autoSizer.updateElem(elem, true, elem.offsetWidth);
			}

			elem._lazyRace = true;
			isLoading++;

			lazyUnveil(elem, detail, isAuto, sizes, isImg);
		};

		var afterScroll = debounce(function(){
			lazySizesCfg.loadMode = 3;
			throttledCheckElements();
		});

		var altLoadmodeScrollListner = function(){
			if(lazySizesCfg.loadMode == 3){
				lazySizesCfg.loadMode = 2;
			}
			afterScroll();
		};

		var onload = function(){
			if(isCompleted){return;}
			if(Date.now() - started < 999){
				setTimeout(onload, 999);
				return;
			}


			isCompleted = true;

			lazySizesCfg.loadMode = 3;

			throttledCheckElements();

			addEventListener('scroll', altLoadmodeScrollListner, true);
		};

		return {
			_: function(){
				started = Date.now();

				lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
				preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);

				addEventListener('scroll', throttledCheckElements, true);

				addEventListener('resize', throttledCheckElements, true);

				addEventListener('pageshow', function (e) {
					if (e.persisted) {
						var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);

						if (loadingElements.length && loadingElements.forEach) {
							requestAnimationFrame(function () {
								loadingElements.forEach( function (img) {
									if (img.complete) {
										unveilElement(img);
									}
								});
							});
						}
					}
				});

				if(window.MutationObserver){
					new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
				} else {
					docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
					docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
					setInterval(throttledCheckElements, 999);
				}

				addEventListener('hashchange', throttledCheckElements, true);

				//, 'fullscreenchange'
				['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend'].forEach(function(name){
					document[_addEventListener](name, throttledCheckElements, true);
				});

				if((/d$|^c/.test(document.readyState))){
					onload();
				} else {
					addEventListener('load', onload);
					document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
					setTimeout(onload, 20000);
				}

				if(lazysizes.elements.length){
					checkElements();
					rAF._lsFlush();
				} else {
					throttledCheckElements();
				}
			},
			checkElems: throttledCheckElements,
			unveil: unveilElement,
			_aLSL: altLoadmodeScrollListner,
		};
	})();


	var autoSizer = (function(){
		var autosizesElems;

		var sizeElement = rAFIt(function(elem, parent, event, width){
			var sources, i, len;
			elem._lazysizesWidth = width;
			width += 'px';

			elem.setAttribute('sizes', width);

			if(regPicture.test(parent.nodeName || '')){
				sources = parent.getElementsByTagName('source');
				for(i = 0, len = sources.length; i < len; i++){
					sources[i].setAttribute('sizes', width);
				}
			}

			if(!event.detail.dataAttr){
				updatePolyfill(elem, event.detail);
			}
		});
		/**
		 *
		 * @param elem {Element}
		 * @param dataAttr
		 * @param [width] { number }
		 */
		var getSizeElement = function (elem, dataAttr, width){
			var event;
			var parent = elem.parentNode;

			if(parent){
				width = getWidth(elem, parent, width);
				event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});

				if(!event.defaultPrevented){
					width = event.detail.width;

					if(width && width !== elem._lazysizesWidth){
						sizeElement(elem, parent, event, width);
					}
				}
			}
		};

		var updateElementsSizes = function(){
			var i;
			var len = autosizesElems.length;
			if(len){
				i = 0;

				for(; i < len; i++){
					getSizeElement(autosizesElems[i]);
				}
			}
		};

		var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

		return {
			_: function(){
				autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
				addEventListener('resize', debouncedUpdateElementsSizes);
			},
			checkElems: debouncedUpdateElementsSizes,
			updateElem: getSizeElement
		};
	})();

	var init = function(){
		if(!init.i && document.getElementsByClassName){
			init.i = true;
			autoSizer._();
			loader._();
		}
	};

	setTimeout(function(){
		if(lazySizesCfg.init){
			init();
		}
	});

	lazysizes = {
		/**
		 * @type { LazySizesConfigPartial }
		 */
		cfg: lazySizesCfg,
		autoSizer: autoSizer,
		loader: loader,
		init: init,
		uP: updatePolyfill,
		aC: addClass,
		rC: removeClass,
		hC: hasClass,
		fire: triggerEvent,
		gW: getWidth,
		rAF: rAF,
	};

	return lazysizes;
}
));


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!********************************!*\
  !*** ./src/assets/js/theme.js ***!
  \********************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lazysizes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lazysizes */ "./node_modules/lazysizes/lazysizes.js");
/* harmony import */ var lazysizes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lazysizes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @shopify/theme-sections */ "./node_modules/@shopify/theme-sections/theme-sections.js");
/* harmony import */ var _shopify_theme_product_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @shopify/theme-product-form */ "./node_modules/@shopify/theme-product-form/theme-product-form.js");
/* harmony import */ var _shopify_theme_cart__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @shopify/theme-cart */ "./node_modules/@shopify/theme-cart/theme-cart.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





(lazysizes__WEBPACK_IMPORTED_MODULE_0___default().cfg.loadHidden) = false;

(function () {
  var bootTheme = function bootTheme() {
    // Some polyfills not provided yet by polyfills.io
    if (window.NodeList && !NodeList.prototype.forEach) {
      NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;

        for (var i = 0; i < this.length; i++) {
          callback.call(thisArg, this[i], i, this);
        }
      };
    }

    var _classCallCheck = function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    };

    var _defineProperties = function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    };

    var _createClass = function _createClass(Constructor, protoProps, staticProps) {
      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
      if (staticProps) _defineProperties(Constructor, staticProps);
      return Constructor;
    }; // read more here 
    // https://www.npmjs.com/package/@shopify/theme-sections


    var _TotalOffsetTop = function _TotalOffsetTop(e) {
      var offset = 0;

      do {
        offset += e.offsetTop;
      } while (e = e.offsetParent);

      return offset;
    }; // var debounce = function() {
    // function debounce(fn, wait) {
    //   let t;
    //   return (...args) => {
    //     clearTimeout(t);
    //     t = setTimeout(() => fn.apply(this, args), wait);
    //   };
    // }
    // }
    // new debounce();


    var CartDrawer = function () {
      function CartDrawer() {
        if (document.querySelector('.cart-drawer-main')) {
          _classCallCheck(this, CartDrawer);

          this.cart_drawer = document.querySelector('.cart-drawer-main');
          this.timer = null;
          this.attachListeners();
        }
      }

      _createClass(CartDrawer, [{
        key: "attachListeners",
        value: function attachListeners() {
          var _this2 = this;

          this.cart_drawer.querySelectorAll('[name^="updates"]').forEach(function (el) {
            el.addEventListener('change', _this2._onChange.bind(_this2));
          });
          this.cart_drawer.querySelectorAll('.btn-delete-item').forEach(function (el) {
            el.addEventListener('click', _this2._removeItem.bind(_this2));
          });
          var swiper_options_thumb = {
            autoHeight: true,
            pagination: {
              el: ".swiper-pagination.upsell",
              clickable: true
            }
          };

          if (document.querySelector('.cartproduct_slider')) {
            var upsells_slider = new Swiper(document.querySelector('.cartproduct_slider'), swiper_options_thumb);
          }

          if (typeof callback == 'function') {
            callback();
          }
        }
      }, {
        key: "_setupUpsellForm",
        value: function _setupUpsellForm() {
          var _this3 = this;

          var formElement = this.cart_drawer.querySelector('[data-product-form]');

          if (formElement) {
            var productHandle = formElement.dataset.productHandle;

            if (productHandle) {
              fetch("/products/".concat(productHandle, ".js")).then(function (response) {
                return response.json();
              }).then(function (productJSON) {
                _this3.productForm = new _shopify_theme_product_form__WEBPACK_IMPORTED_MODULE_2__.ProductForm(formElement, productJSON, {
                  onFormSubmit: _this3._onFormSubmit.bind(formElement)
                });
              });
            }
          }
        }
      }, {
        key: '_onFormSubmit',
        value: function _onFormSubmit(event) {
          var form = this;
          var btn = form.querySelector('[type="submit"]');
          btn.classList.add('adding-to-cart');
          event.preventDefault();
          _shopify_theme_cart__WEBPACK_IMPORTED_MODULE_3__.addItemFromForm(form).then(function (item) {})["catch"](function (error) {
            console.log('A problem occured adding to cart');
          })["finally"](function () {
            btn.classList.remove('adding-to-cart');
            window.Shopify.theme.CartDrawer.updateCart(true);
          });
        }
      }, {
        key: "_onChange",
        value: function _onChange(event) {
          var target = event.currentTarget;
          var key = target.dataset.key;
          var quantity = target.value * 1;
          clearTimeout(this.timer);
          this.timer = setTimeout(function () {
            if (key) {
              this.cart_drawer.querySelectorAll('.qty-picker button').forEach(function (el) {
                return el.setAttribute('disabled', true);
              });
              _shopify_theme_cart__WEBPACK_IMPORTED_MODULE_3__.updateItem(key, {
                quantity: quantity
              }).then(function (state) {
                window.Shopify.theme.CartDrawer.updateCart();
              })["catch"](function (error) {
                console.log('An error occured updating line item.');
              });
            }
          }.bind(this), 400);
        }
      }, {
        key: '_removeItem',
        value: function _removeItem(event) {
          var target = event.currentTarget;
          var key = target.dataset.key;
          _shopify_theme_cart__WEBPACK_IMPORTED_MODULE_3__.removeItem(key).then(function (state) {
            window.Shopify.theme.CartDrawer.updateCart();
          });
          event.preventDefault();
        }
      }, {
        key: "openCart",
        value: function openCart() {
          if (this.cart_drawer) {
            this.cart_drawer.classList.add('cart-open');
            document.body.classList.add('overflow-hidden');
          }
        }
      }, {
        key: "closeCart",
        value: function closeCart() {
          if (this.cart_drawer) {
            this.cart_drawer.classList.remove('cart-open');
            document.body.classList.remove('overflow-hidden');
          }
        }
      }, {
        key: "updateCart",
        value: function updateCart(openCart) {
          var _this4 = this;

          var cartUrl = "/cart?view=mini";
          fetch(cartUrl).then(function (response) {
            return response.text();
          }).then(function (cart) {
            if (cart.trim() === '') {
              return;
            }

            var tempDiv = document.createElement("div");
            tempDiv.innerHTML = cart; // if(tempDiv.querySelector('.cart--count')){
            // let cart_count = tempDiv.querySelector('.cart--count').innerHTML;
            // let cart_icon = document.querySelector('.noti-class');
            // cart_icon.innerHTML = cart_count; 
            // }

            var cart = tempDiv.querySelector('.shopify-section');

            if (_this4.cart_drawer) {
              _this4.cart_drawer.innerHTML = cart.innerHTML;

              _this4.attachListeners();

              _this4._setupUpsellForm();

              new QuantityPicker(_this4.cart_drawer);

              if (openCart) {
                setTimeout(function () {
                  _this4.openCart();
                }, 50);
              }
            }
          });
        }
      }]);

      return CartDrawer;
    }();

    window.Shopify.theme.CartDrawer = new CartDrawer();

    var QuantityPicker = function () {
      function QuantityPicker(element) {
        _classCallCheck(this, QuantityPicker);

        this.element = element ? element : document;
        this.qty_selectors = this.element.querySelectorAll('.qty-picker'); // this.options = options;

        this._attachListeners();
      }

      _createClass(QuantityPicker, [{
        key: "_attachListeners",
        value: function _attachListeners() {
          var _this = this;

          if (this.qty_selectors && this.qty_selectors.length > 0) {
            this.qty_selectors.forEach(function (el) {
              var button1 = el.querySelector('button.minus');
              var button2 = el.querySelector('button.plus');
              var qty_el = el.querySelector('input');
              button1.addEventListener('click', _this._quantityMinus.bind(_this, qty_el));
              button2.addEventListener('click', _this._quantityPlus.bind(_this, qty_el));
              qty_el.addEventListener('blur', _this._onInputBlur.bind(_this));
            });
          }
        }
      }, {
        key: "_quantityMinus",
        value: function _quantityMinus(qty_el) {
          var min = qty_el.getAttribute('data-min') * 1;
          var num = qty_el.value * 1;

          if (isNaN(num)) {
            num = min;
          }

          qty_el.value = num - 1 < min ? min : num - 1;

          if (qty_el.classList.contains('pdp-qty') && qty_el.dataset.target) {
            try {
              document.body.querySelectorAll('.'.concat(qty_el.dataset.target)).forEach(function (input) {
                input.value = qty_el.value;
              });
            } catch (error) {}
          }

          qty_el.dispatchEvent(new Event("change"));
        }
      }, {
        key: "_quantityPlus",
        value: function _quantityPlus(qty_el) {
          var num = qty_el.value * 1;
          var max = qty_el.dataset.max * 1;

          if (isNaN(num)) {
            num = 0;
          }

          if (!isNaN(max) && max != 0 && num >= max) {
            num = max - 1;
          }

          qty_el.value = num + 1;

          if (qty_el.classList.contains('pdp-qty') && qty_el.dataset.target) {
            try {
              document.body.querySelectorAll('.'.concat(qty_el.dataset.target)).forEach(function (input) {
                input.value = qty_el.value;
              });
            } catch (error) {}
          }

          qty_el.dispatchEvent(new Event("change"));
        }
      }, {
        key: "_onInputBlur",
        value: function _onInputBlur(e) {
          var min = e.target.getAttribute('data-min') * 1;
          var default_value = e.target.getAttribute('data-default') * 1;

          if (isNaN(e.target.value)) {
            e.target.value = default_value ? default_value : min;
          }

          ;

          if (e.target.classList.contains('pdp-qty') && e.target.dataset.target) {
            try {
              document.body.querySelectorAll('.'.concat(e.target.dataset.target)).forEach(function (input) {
                input.value = e.target.value;
              });
            } catch (error) {}
          }
        }
      }]);

      return QuantityPicker;
    }();

    new QuantityPicker();
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('header-section', {
      onLoad: function onLoad() {
        var _this5 = this;

        this._attachEvent();

        if (this.container.querySelector('.btn-cart-drawer')) {
          window.Shopify.theme.CartDrawer.updateCart();
        }

        this._setupSlider();

        document.addEventListener('click', this._toggleSearch.bind(this));
        this.container.querySelectorAll('.search-toggle-btn').forEach(function (el) {
          el.addEventListener('click', _this5._openSearchBox.bind(_this5));
        });
        this.container.querySelectorAll('.mobile-menu-toggle').forEach(function (el) {
          el.addEventListener('click', _this5._toggleMobileMenu.bind(_this5));
        });
        this.container.querySelectorAll('.child-link').forEach(function (el) {
          el.addEventListener('click', _this5._toggleChildLink.bind(_this5));
        });
        this.container.querySelectorAll('.grand-child-link').forEach(function (el) {
          el.addEventListener('click', _this5._toggleGrandChildLink.bind(_this5));
        });
      },
      _toggleGrandChildLink: function _toggleGrandChildLink(event) {
        event.preventDefault();
        var target = event.currentTarget;
        var toggle_menu = target.closest('li').querySelector('.grand-child-ul');
        toggle_menu.classList.toggle('hidden');
      },
      _toggleChildLink: function _toggleChildLink(event) {
        event.preventDefault();
        var target = event.currentTarget;
        var toggle_menu = target.closest('li').querySelector('.child-ul');
        toggle_menu.classList.toggle('hidden');
      },
      _toggleMobileMenu: function _toggleMobileMenu(event) {
        event.preventDefault();
        var menu = this.container.querySelector('.header-menu-bar');

        if (!document.querySelector('body').classList.contains('menu-open')) {
          this.scrollLeft = window.scrollX * 1;
          this.scrollTop = window.scrollY * 1;
        }

        menu.classList.toggle('open-mobilemenu');
        document.querySelector('body').classList.toggle('menu-open');

        if (menu.classList.contains('open-mobilemenu')) {
          document.querySelector('html').style.overflow = "hidden";

          window.onscroll = function () {
            window.scrollTo(this.scrollLeft, this.scrollTop);
          };
        } else {
          window.scrollTo(this.scrollLeft, this.scrollTop);

          window.onscroll = function () {};

          document.querySelector('html').style.overflow = "auto";
        }
      },
      _toggleSearch: function _toggleSearch(event) {
        var target = event.target;

        if (!target.closest('.search_section')) {
          this.container.querySelectorAll('.mobile-serach-box').forEach(function (el) {
            el.classList.add('hidden');
          });
        }
      },
      _openSearchBox: function _openSearchBox(event) {
        var target = event.currentTarget;

        if (target.classList.contains('search-toggle-btn')) {
          var search_box_id = target.getAttribute('data-searchid');
          var search_box = this.container.querySelector(search_box_id);
          search_box.classList.toggle('hidden');
          event.preventDefault();
        } else if (target.classList.contains('serach-input')) {} else {
          var seach_input = this.container.querySelectorAll('.mobile-serach-box');
          seach_input.forEach(function (el) {
            return el.classList.add('hidden');
          });
        }
      },
      _attachEvent: function _attachEvent() {
        if (this.container.querySelector('.btn-cart-drawer')) {
          var btn_cart_drawer = this.container.querySelector('.btn-cart-drawer');

          if (btn_cart_drawer != '') {
            btn_cart_drawer.addEventListener('click', this._cart_drawer_open.bind(this));
          }

          var cart_drawer = this.container.querySelector('.cart-drawer-main');

          if (cart_drawer) {
            cart_drawer.addEventListener('click', this._cart_drawer_events.bind(this));
          }
        }
      },
      _cart_drawer_events: function _cart_drawer_events(event) {
        if (event.target.classList.contains('cart-open') || event.target.classList.contains('cart-drawer--btn-close') || event.target.closest('.cart-drawer--btn-close')) {
          window.Shopify.theme.CartDrawer.closeCart();
          event.preventDefault();
          return;
        }
      },
      _cart_drawer_open: function _cart_drawer_open(event) {
        window.Shopify.theme.CartDrawer.openCart();
        event.preventDefault();
      },
      _setupSlider: function _setupSlider(callback) {
        var swiper_options_thumb = {
          autoHeight: true,
          pagination: {
            el: ".swiper-pagination.upsell"
          }
        };

        if (document.querySelector('.cartproduct_slider')) {
          var upsells_slider = new Swiper(document.querySelector('.cartproduct_slider'), swiper_options_thumb);
        }

        if (typeof callback == 'function') {
          callback();
        }
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('product-section', {
      onLoad: function onLoad() {
        this._setupForm();

        this._setupGallery();
      },
      onUnload: function onUnload() {
        this._destroyGallery();

        if (this.productForm && typeof this.productForm.destroy == 'function') {
          this.productForm.destroy();
        }
      },
      _setupForm: function _setupForm() {
        var _this6 = this;

        var formElement = this.container.querySelector('[data-product-form]');
        var forms = [formElement];
        var productHandle = formElement.dataset.productHandle;
        var selector = '[data-product-handle="'.concat(productHandle, '"]');

        if (productHandle) {
          fetch("/products/".concat(productHandle, ".js")).then(function (response) {
            return response.json();
          }).then(function (productJSON) {
            try {
              forms = document.querySelectorAll(selector);
            } catch (error) {}

            forms.forEach(function (formElement) {
              _this6.productForm = new _shopify_theme_product_form__WEBPACK_IMPORTED_MODULE_2__.ProductForm(formElement, productJSON, {
                onOptionChange: _this6._onOptionChange.bind(_this6),
                onFormSubmit: _this6._onFormSubmit.bind(formElement)
              });
            });
          });
        }
      },
      _onFormSubmit: function _onFormSubmit(event) {
        var form = this;
        var btn = form.querySelector('[type="submit"]');
        var qty = form.querySelector('[name="quantity"]').value;

        if (qty == '') {
          event.preventDefault();
          alert('Select Quantity');
          return;
        }

        event.preventDefault();
        btn.classList.add('adding-to-cart');
        btn.disabled = true;
        _shopify_theme_cart__WEBPACK_IMPORTED_MODULE_3__.addItemFromForm(form).then(function (item) {})["catch"](function (error) {
          console.log('A problem occured adding to cart');
        })["finally"](function () {
          btn.classList.remove('adding-to-cart');
          btn.disabled = false;

          if (document.querySelector('.btn-cart-drawer')) {
            window.Shopify.theme.CartDrawer.updateCart(true);
          } else {
            window.location = window.routes.cart_url;
          }
        });
      },
      _onQuantityChange: function _onQuantityChange(event) {},
      _onOptionChange: function _onOptionChange(event) {
        var variant = event.dataset.variant;
        var btn_atc = this.container.querySelector('[type="submit"]');
        var price_cont = this.container.querySelector('.price span');

        if (variant) {
          this.container.querySelector('[name="id"]').value = variant.id;
          price_cont.innerHTML = window.languages.moneyFormat.replace('{{amount}}', (variant.price / 100).toFixed(2));
        }

        if (variant === null) {
          btn_atc.setAttribute('disabled', true);
          btn_atc.querySelector('span').innerHTML = window.languages.productFormUnavailable;
        } else if (variant && !variant.available) {
          btn_atc.setAttribute('disabled', true);
          btn_atc.querySelector('span').innerHTML = window.languages.productFormUnavailable;
        } else if (variant && variant.available) {
          btn_atc.removeAttribute('disabled');
          btn_atc.querySelector('span').innerHTML = window.languages.productFormAddToCart;
        }

        if (!variant) {
          return;
        }

        var url = _shopify_theme_product_form__WEBPACK_IMPORTED_MODULE_2__.getUrlWithVariant(window.location.href, variant.id);
        window.history.replaceState({
          path: url
        }, '', url);

        this._setImage(variant);

        this._setQuantity(variant);
      },
      _setImage: function _setImage(variant) {
        var selector = '.gallery-top.product-slider-top [data-image="'.concat(variant.featured_media.id, '"]');
        var image = null;

        try {
          image = this.container.querySelector(selector);
        } catch (error) {}

        if (image) {
          var index = image.dataset.index;

          if (!isNaN(index) && this.galleryTop && typeof this.galleryTop.slideTo == 'function') {
            this.galleryTop.slideTo(index);
          }
        }
      },
      _setQuantity: function _setQuantity(variant) {
        var qty = 0;
        var qty_el = this.container.querySelector('.shopify-product-form [name="quantity"]');

        if (variant) {
          var option = null;

          try {
            option = this.container.querySelector('[name="id"] option[value="'.concat(variant.id, '"]'));
            qty = option.dataset.qty * 1;
          } catch (error) {}
        }

        if (qty > 0) {
          var option_html = '';

          for (var i = 0; i < qty; i++) {
            option_html += '<option value="' + (i + 1) + '">' + (i + 1) + '</option>';
          }

          qty_el.innerHTML = option_html;
        }
      },
      _qty_btn_click: function _qty_btn_click(event) {
        var target = event.currentTarget;
        var qty_input = this.querySelector('[name="quantity"]'); // qty_input.value = target.classList.contains('minus') ? (qty_input.value*1 - 1) : (qty_input.value*1 + 1);

        qty_input.value = qty_input.value;

        if (qty_input.value < 1) {
          qty_input.value = 1;
        }
      },
      _setupGallery: function _setupGallery(callback) {
        var _breakpoints;

        var swiper_options_thumb = {
          spaceBetween: 15,
          slidesPerView: 3,
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next.thumbnails',
            prevEl: ".swiper-button-prev.thumbnails"
          },
          breakpoints: (_breakpoints = {
            768: {
              spaceBetween: 15
            }
          }, _defineProperty(_breakpoints, "768", {
            spaceBetween: 15,
            slidesPerView: 4
          }), _defineProperty(_breakpoints, 1280, _defineProperty({
            slidesPerView: 4
          }, "slidesPerView", 4)), _defineProperty(_breakpoints, 1536, {
            slidesPerView: 4,
            spaceBetween: 20
          }), _breakpoints)
        };
        var galleryThumbs = new Swiper(this.container.querySelector('.gallery-thumbs.product-slider-thumbs'), swiper_options_thumb);
        var swiper_options = {
          spaceBetween: 10,
          slidesPerView: 1,
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next.main-gallery',
            prevEl: '.swiper-button-prev.main-gallery'
          },
          thumbs: {
            swiper: galleryThumbs
          }
        };
        this.galleryThumbs = galleryThumbs;
        var gallery = this.container.querySelector('.gallery-top.product-slider-top');
        var activeSlide = gallery.querySelector('.swiper-slide.active');

        if (activeSlide) {
          swiper_options.initialSlide = activeSlide.dataset.index || 0;
        }

        this.galleryTop = new Swiper(gallery, swiper_options);

        if (typeof callback == 'function') {
          callback();
        }
      },
      _destroyGallery: function _destroyGallery() {
        if (this.galleryThumbs && typeof this.galleryThumbs.destroy == 'function') {
          this.galleryThumbs.destroy();
        }

        if (this.galleryTop && typeof this.galleryTop.destroy == 'function') {
          this.galleryTop.destroy();
        }
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('collection-section', {
      onLoad: function onLoad() {
        var _this7 = this;

        this.container.querySelectorAll('.btn-add-to-cart').forEach(function (el) {
          return el.addEventListener('click', _this7._setupForm.bind(_this7));
        });
        this.sort_options = this.container.querySelectorAll('.sort-options');
        this.sort_options.forEach(function (el) {
          return el.addEventListener('click', _this7._clickSort.bind(_this7));
        });

        if (this.container.querySelectorAll('.filter--btn')) {
          this.container.querySelectorAll('.filter--btn').forEach(function (el) {
            return el.addEventListener('click', _this7._openFilterBox.bind(_this7));
          });
        }

        if (this.container.querySelectorAll('.def-filters')) {
          this.container.querySelectorAll('.def-filters').forEach(function (el) {
            return el.addEventListener('click', _this7._applyFilter.bind(_this7));
          });
        }

        if (this.container.querySelector('.toggle-filter-drawer')) {
          this.container.querySelectorAll('.toggle-filter-drawer').forEach(function (el) {
            return el.addEventListener('click', _this7._openFilterMenu.bind(_this7));
          });
        }
      },
      _setupForm: function _setupForm(event) {
        var btn = event.currentTarget;
        event.preventDefault();
        var form = btn.closest('[action="/cart/add"]');

        if (form) {
          btn.classList.add('adding-to-cart');
          btn.disabled = true;
          _shopify_theme_cart__WEBPACK_IMPORTED_MODULE_3__.addItemFromForm(form).then(function (item) {})["catch"](function (error) {
            console.log('A problem occured adding to cart');
          })["finally"](function () {
            btn.classList.remove('adding-to-cart');
            btn.disabled = false;

            if (document.querySelector('.btn-cart-drawer')) {
              window.Shopify.theme.CartDrawer.updateCart(true);
            } else {
              window.location = window.routes.cart_url;
            }
          });
        }
      },
      _onFormSubmit: function _onFormSubmit(event) {
        var form = this;
        var btn = form.querySelector('[type="submit"]');
        event.preventDefault();
        btn.classList.add('adding-to-cart');
        btn.disabled = true;
        _shopify_theme_cart__WEBPACK_IMPORTED_MODULE_3__.addItemFromForm(form).then(function (item) {})["catch"](function (error) {
          console.log('A problem occured adding to cart');
        })["finally"](function () {
          btn.classList.remove('adding-to-cart');
          btn.disabled = false;

          if (document.querySelector('.btn-cart-drawer')) {
            window.Shopify.theme.CartDrawer.updateCart(true);
          } else {
            window.location = window.routes.cart_url;
          }
        });
      },
      _applyFilter: function _applyFilter(event) {
        event.preventDefault();
        var target = event.currentTarget;
        var link = target.closest('.custome-checkbox').querySelector('a').getAttribute('href');
        setTimeout(function () {
          window.location = link;
        }, 500);
      },
      _openFilterBox: function _openFilterBox(event) {
        event.preventDefault();
        var target = event.currentTarget;
        var box = target.closest('.filter_dropdown').querySelector('.mobile_dropdown');

        if (box) {
          box.classList.toggle('hidden');
        }
      },
      _openFilterMenu: function _openFilterMenu(event) {
        event.preventDefault();
        var target = this.container.querySelector('.product-filter-section');
        target.classList.toggle('open-mobilefilter');
      },
      _clickSort: function _clickSort(event) {
        event.preventDefault();
        var target = event.currentTarget;
        var new_sort = target.closest('a').getAttribute('href');
        Shopify.queryParams = {};

        if (location.search.length) {
          for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');

            if (aKeyValue.length > 1) {
              Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
            }
          }
        }

        Shopify.queryParams.sort_by = new_sort;
        setTimeout(function () {
          location.search = new URLSearchParams(Shopify.queryParams).toString();
        }, 500);
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('product-tabs-section', {
      onLoad: function onLoad() {
        var _this8 = this;

        this.tabs_row = this.container.querySelector('.tab-row');
        this.tabs_anchor = this.tabs_row.querySelectorAll('.tab-row a.tab-heading');
        this.active_tab = null;
        this.tabs_anchor.forEach(function (el) {
          return el.addEventListener('click', _this8._tab_click.bind(_this8));
        }); // this.tabs_row.querySelectorAll('.btn-cart-drawer').forEach(el => el.addEventListener('click', this._open_cart.bind(this) ) );

        window.addEventListener('scroll', this._tabActive.bind(this));
        window.addEventListener('resize', this._tabActive.bind(this));

        this._tabActive();

        this._setupGallery();
      },
      onUnload: function onUnload() {
        this._destroyGallery();
      },
      _setupGallery: function _setupGallery(callback) {
        var swiper_options_thumb_1 = {
          loop: false,
          spaceBetween: 10,
          slidesPerView: 3,
          // grabCursor: false,
          // allowTouchMove: false,
          // autoHeight: true,
          // centeredSlides: true,
          autoplay: {
            delay: 2500,
            // disableOnInteraction: false,
            pauseOnMouseEnter: true
          },
          breakpoints: {
            100: {
              slidesPerView: 3,
              spaceBetween: 15,
              freeMode: true,
              watchSlidesVisibility: true,
              watchSlidesProgress: true
            },
            640: {
              slidesPerView: 3,
              spaceBetween: 10,
              freeMode: true,
              watchSlidesVisibility: true,
              watchSlidesProgress: true
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 10
            }
          }
        };
        var galleryThumbs = new Swiper(this.container.querySelector('.contentsliderSwiper'), swiper_options_thumb_1);
        var swiper_options_1 = {
          loop: false,
          threshold: 3,
          spaceBetween: 0,
          // allowTouchMove: false,
          centeredSlides: true,
          autoHeight: true,
          autoplay: {
            delay: 2500,
            // disableOnInteraction: false,
            pauseOnMouseEnter: true
          },
          navigation: {
            nextEl: this.container.querySelector('.swiper-button-next'),
            prevEl: this.container.querySelector('.swiper-button-prev')
          },
          // pagination: {
          //     el: this.container.querySelector('.swiper-pagination'),
          //     clickable: true,
          // }, 
          breakpoints: {
            768: {
              autoHeight: false
            }
          },
          thumbs: {
            swiper: galleryThumbs
          }
        };
        this.galleryThumbs = galleryThumbs;
        var gallery = this.container.querySelector('.ingredients-slider .thumbsSliderSwiper');
        this.galleryTop = new Swiper(gallery, swiper_options_1);



        var swiper_benefit_options = {
          autoplay: {
            delay: 1000,
            disableOnInteraction: false
          },
          pagination: {
            el: ".swiper-pagination",
            dynamicBullets: true,
            clickable: true
          },
          breakpoints: {
            200: {
              loop: true,
              direction: 'horizontal', 
              slidesPerView: 2,
              noSwiping: true,
              spaceBetween: 0,
              centeredSlides: false,
              autoplay: false, // Disabled autoplay
              loop: false,
            },
            640: {
              loop: true,
              direction: 'horizontal', 
              slidesPerView: 2,
              noSwiping: true,
              spaceBetween: 0,
               des: false,
              autoplay: false, // Disabled autoplay
              loop: false,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 20,
              noSwiping: false,
              allowSlidePrev: false,
              allowSlideNext: false,
              spaceBetween: 10
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 20,
              noSwiping: false,
              allowSlidePrev: false,
              allowSlideNext: false
            }
          }
        };
        var benefit_slider_id = this.container.querySelector('.benefits-content-slider');
        var benefit_slider = new Swiper(benefit_slider_id, swiper_benefit_options);
        
        if (typeof callback == 'function') {
          callback();
        }
      },
      _destroyGallery: function _destroyGallery() {
        if (this.galleryThumbs && typeof this.galleryThumbs.destroy == 'function') {
          this.galleryThumbs.destroy();
        }

        if (this.galleryTop && typeof this.galleryTop.destroy == 'function') {
          this.galleryTop.destroy();
        }
      },
      _tabActive: function _tabActive() {
        var _this9 = this;

        this.tabs_anchor.forEach(function (target) {
          _this9.active_tab && target.classList.remove('active');
          var selector = target.getAttribute('href');
          var el = null;

          if (selector.indexOf('#') != -1) {
            el = _this9._getTarget(target.getAttribute('href'));
          }

          var mark = 0;

          if (el) {
            mark = _TotalOffsetTop(el) - _this9.tabs_row.clientHeight - _TotalOffsetTop(_this9.tabs_row) - 10; // target.dataset.mark = mark;
            // console.log(mark, target.getAttribute('href'))
          }

          if (el && mark < 1) {
            _this9.active_tab = target;
          }
        });

        if (this.active_tab) {
          this.active_tab.classList.add('active'); // this.active_tab.scrollIntoView({behavior: "smooth"});
        }
      },
      _tab_click: function _tab_click(event) {
        var target = event.currentTarget;

        var el = this._getTarget(target.getAttribute('href'));

        if (el) {
          window.scrollTo({
            behavior: 'smooth',
            top: _TotalOffsetTop(el) - this.tabs_row.clientHeight - 10
          });
          event.preventDefault();
        }
      },
      _getTarget: function _getTarget(selector) {
        if (!selector) {
          return null;
        }

        var el = null;

        try {
          el = this.container.querySelector(selector);
        } catch (error) {
          console.log(error);
        }

        return el;
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('blog-section', {
      onLoad: function onLoad() {
        var _this10 = this;

        this._attachListeners();

        this._attachListeners_2();

        if (this.container.querySelectorAll('.blog-category-link')) {
          this.blog_link = this.container.querySelectorAll('.blog-category-link');
          this.blog_link.forEach(function (el) {
            return el.addEventListener('click', _this10._blogCategory.bind(_this10));
          });
        }

        if (this.container.querySelector('.toggle-blogs')) {
          this.container.querySelector('.toggle-blogs').addEventListener('click', this._toggleMenu.bind(this));
        }
      },
      _attachListeners_2: function _attachListeners_2() {
        var self = this;
        this.container.addEventListener('click', function (e) {
          var target = e.target;

          if (target.closest('.paginate_sec') && target.tagName.toLowerCase() === 'a') {
            var pagination = target.closest('.paginate_sec');

            if (pagination.closest('.artcles-cont-1')) {
              e.stopImmediatePropagation();
              e.preventDefault();
              var url = target.getAttribute('href');
              fetch(url).then(function (response) {
                if (!response.ok) {
                  var error = new Error(response.status); // this.close();

                  throw error;
                }

                return response.text();
              }).then(function (text) {
                var tempDiv = document.createElement("div");
                tempDiv.innerHTML = text;
                var search_page = tempDiv.querySelector('#shopify-section-blog-search-result');
                var article_columns = search_page.querySelectorAll('.blog-item');
                var article_container = search_page.querySelector('.article-search--content').innerHTML;

                if (article_columns.length > 0) {
                  self.container.querySelector('.blog--container').style.display = 'none';
                  self.container.querySelector('.search--container').style.display = 'block';
                  self.container.querySelector('.artcles-cont-1').innerHTML = article_container; // self.container.querySelector('.artcles-cont-1').scrollIntoView({behavior: "smooth"});

                  var element = self.container.querySelector('.artcles-cont-1');
                  var offset = 200;
                  var bodyRect = document.body.getBoundingClientRect().top;
                  var elementRect = element.getBoundingClientRect().top;
                  var elementPosition = elementRect - bodyRect;
                  var offsetPosition = elementPosition - offset;
                  window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                  });

                  self._attachListeners_2();
                } else {}
              })["catch"](function (error) {
                throw error;
              });
            }
          }
        });

        if (this.container.querySelectorAll('.artcles-cont-1 .paginate_sec a')) {
          this.pagination_link = this.container.querySelectorAll('.artcles-cont-1 .paginate_sec a'); // this.pagination_link.forEach(el => el.addEventListener('click', this._showNextPage.bind(this) ) );
        }
      },
      _showNextPage: function _showNextPage(event) {
        var _this11 = this;

        event.preventDefault();
        var target = event.target;
        var url = target.getAttribute('href');
        fetch(url).then(function (response) {
          if (!response.ok) {
            var error = new Error(response.status); // this.close();

            throw error;
          }

          return response.text();
        }).then(function (text) {
          var tempDiv = document.createElement("div");
          tempDiv.innerHTML = text;
          var search_page = tempDiv.querySelector('#shopify-section-blog-search-result');
          var article_columns = search_page.querySelectorAll('.blog-item');
          var article_container = search_page.querySelector('.article-search--content').innerHTML;

          if (article_columns.length > 0) {
            _this11.container.querySelector('.blog--container').style.display = 'none';
            _this11.container.querySelector('.search--container').style.display = 'block';
            _this11.container.querySelector('.artcles-cont-1').innerHTML = article_container; // this.container.querySelector('.artcles-cont-1').scrollIntoView({behavior: "smooth"});

            var element = _this11.container.querySelector('.artcles-cont-1');

            var offset = 150;
            var bodyRect = document.body.getBoundingClientRect().top;
            var elementRect = element.getBoundingClientRect().top;
            var elementPosition = elementRect - bodyRect;
            var offsetPosition = elementPosition - offset;
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });

            _this11._attachListeners_2();
          } else {}
        })["catch"](function (error) {
          throw error;
        });
      },
      _toggleMenu: function _toggleMenu(event) {
        event.preventDefault();
        this.container.querySelector('.blog-menu-container').classList.toggle('hidden');
      },
      _blogCategory: function _blogCategory(event) {
        var target = event.currentTarget;
        var link = target.getAttribute('data-link');
        setTimeout(function () {
          window.location = link;
        }, 500);
      },
      _attachListeners: function _attachListeners() {
        var _this13 = this;

        var form = document.querySelector('#article-search-form');
        form.addEventListener('submit', function (e) {
          e.preventDefault();
        });

        function debounce(fn, wait) {
          var _this12 = this;

          var t;
          return function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            clearTimeout(t);
            t = setTimeout(function () {
              return fn.apply(_this12, args);
            }, wait);
          };
        }

        this.input = this.container.querySelector('.blog-serach-bar');
        this.input.addEventListener('input', this._progressBar.bind(this));
        this.input.addEventListener('input', debounce(function (event) {
          _this13._showArticles(event);
        }, 500).bind(this));
      },
      _progressBar: function _progressBar() {
        var i = 0;

        if (i == 0) {
          var frame = function frame() {
            if (width >= 100) {
              clearInterval(id);
              i = 0;
              elem.style.width = "0";
            } else {
              width++;
              elem.style.width = width + "%";
            }
          };

          i = 1;
          var elem = document.getElementById("status--bar");
          var width = 1;
          var id = setInterval(frame, 7);
        }
      },
      _showArticles: function _showArticles(event) {
        var searchTerm = this.input.value.trim();

        if (searchTerm.length == 0) {
          this.container.querySelector('.blog--container').style.display = 'block';
          this.container.querySelector('.search--container').style.display = 'none';
          var element = this.container.querySelector('.blog--container');
          var offset = 200;
          var bodyRect = document.body.getBoundingClientRect().top;
          var elementRect = element.getBoundingClientRect().top;
          var elementPosition = elementRect - bodyRect;
          var offsetPosition = elementPosition - offset;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        } else {
          this.getSearchResults(searchTerm);
        }
      },
      getSearchResults: function getSearchResults(searchTerm) {
        var _this14 = this;

        var baseUrl = '/search?view=ajax&type=article&q=' + searchTerm;
        fetch(baseUrl).then(function (response) {
          if (!response.ok) {
            var error = new Error(response.status); // this.close();

            throw error;
          }

          return response.text();
        }).then(function (text) {
          var tempDiv = document.createElement("div");
          tempDiv.innerHTML = text;
          var search_page = tempDiv.querySelector('#shopify-section-blog-search-result');
          var article_columns = search_page.querySelectorAll('.blog-item');
          var article_container = search_page.querySelector('.article-search--content').innerHTML;

          if (article_columns.length > 0) {
            _this14.container.querySelector('.blog--container').style.display = 'none';
            _this14.container.querySelector('.search--container').style.display = 'block';
            _this14.container.querySelector('.artcles-cont-1').innerHTML = article_container; // this.container.querySelector('.artcles-cont-1').scrollIntoView({behavior: "smooth"});

            var element = _this14.container.querySelector('.artcles-cont-1');

            var offset = 200;
            var bodyRect = document.body.getBoundingClientRect().top;
            var elementRect = element.getBoundingClientRect().top;
            var elementPosition = elementRect - bodyRect;
            var offsetPosition = elementPosition - offset;
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          } else {}
        })["catch"](function (error) {
          throw error;
        });
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('article-details-page', {
      onLoad: function onLoad() {
        if (this.container.querySelector('.green-btn')) {
          this._setupForm();
        }
      },
      _setupForm: function _setupForm() {
        this.container.querySelector('.green-btn').addEventListener('click', function (event) {
          event.preventDefault();
          var btn = event.target;
          var form = btn.closest('[action="/cart/add"]');

          if (form) {
            btn.disabled = true;
            _shopify_theme_cart__WEBPACK_IMPORTED_MODULE_3__.addItemFromForm(form).then(function (item) {})["catch"](function (error) {
              console.log('A problem occured adding to cart');
            })["finally"](function () {
              btn.disabled = false;

              if (document.querySelector('.btn-cart-drawer')) {
                window.Shopify.theme.CartDrawer.updateCart(true);
              } else {
                window.location = window.routes.cart_url;
              }
            });
          }
        });
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('article-section', {
      onLoad: function onLoad() {
        var _this15 = this;

        if (this.container.querySelector('.toggle-menu-drawer')) {
          this.container.querySelector('.toggle-menu-drawer').addEventListener('click', this._toggleMenu.bind(this));
        }

        this.tabs_row = document.querySelector('.article--row');
        this.tabs_anchor = this.container.querySelectorAll('a.menu-heading');
        this.active_tab = null;
        this.tabs_anchor.forEach(function (el) {
          return el.addEventListener('click', _this15._tab_click.bind(_this15));
        }); // this.tabs_row.querySelectorAll('.btn-cart-drawer').forEach(el => el.addEventListener('click', this._open_cart.bind(this) ) );

        window.addEventListener('scroll', this._tabActive.bind(this));
        window.addEventListener('resize', this._tabActive.bind(this));

        this._tabActive();
      },
      _toggleMenu: function _toggleMenu(event) {
        event.preventDefault();

        if (this.container.querySelector('.article-tabs-row')) {
          this.container.querySelector('.article-tabs-row').classList.toggle('hidden');
        }
      },
      _tabActive: function _tabActive() {
        var _this16 = this;

        this.tabs_anchor.forEach(function (target) {
          _this16.active_tab && target.classList.remove('active');
          var selector = target.getAttribute('href');
          var el = null;

          if (selector.indexOf('#') != -1) {
            el = _this16._getTarget(target.getAttribute('href'));
          }

          var mark = 0;

          if (el) {
            mark = _TotalOffsetTop(el) - _this16.tabs_row.clientHeight - _TotalOffsetTop(_this16.tabs_row) - 180; // target.dataset.mark = mark;
          }

          if (el && mark < 1) {
            _this16.active_tab = target;
          }
        });

        if (this.active_tab) {
          this.active_tab.classList.add('active'); // this.active_tab.scrollIntoView({behavior: "smooth"});
        }
      },
      _tab_click: function _tab_click(event) {
        var target = event.currentTarget;

        var el = this._getTarget(target.getAttribute('href'));

        if (this.container.querySelector('.article-tabs-row')) {
          this.container.querySelector('.article-tabs-row').classList.add('hidden');
        }

        if (el) {
          window.scrollTo({
            behavior: 'smooth',
            top: _TotalOffsetTop(el) - this.tabs_row.clientHeight - 100
          });
          event.preventDefault(); // target.classList.add('active');
        }
      },
      _getTarget: function _getTarget(selector) {
        if (!selector) {
          return null;
        }

        var el = null;

        try {
          el = this.container.querySelector(selector);
        } catch (error) {
          console.log(error);
        }

        return el;
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('white-paper-section', {
      onLoad: function onLoad() {
        var _this17 = this;

        if (this.container.querySelector('.toggle-menu-drawer')) {
          this.container.querySelector('.toggle-menu-drawer').addEventListener('click', this._toggleMenu.bind(this));
        }

        this.tabs_row = document.querySelector('.article--row');
        this.tabs_anchor = this.container.querySelectorAll('a.menu-heading');
        this.active_tab = null;
        this.tabs_anchor.forEach(function (el) {
          return el.addEventListener('click', _this17._tab_click.bind(_this17));
        }); // this.tabs_row.querySelectorAll('.btn-cart-drawer').forEach(el => el.addEventListener('click', this._open_cart.bind(this) ) );

        window.addEventListener('scroll', this._tabActive.bind(this));
        window.addEventListener('resize', this._tabActive.bind(this));

        this._tabActive();
      },
      _toggleMenu: function _toggleMenu(event) {
        event.preventDefault();

        if (this.container.querySelector('.mobile-menu-container')) {
          this.container.querySelector('.mobile-menu-container').classList.toggle('hidden');
        }
      },
      _tabActive: function _tabActive() {
        var _this18 = this;

        this.tabs_anchor.forEach(function (target) {
          _this18.active_tab && target.classList.remove('active');
          var selector = target.getAttribute('href');
          var el = null;

          if (selector.indexOf('#') != -1) {
            el = _this18._getTarget(target.getAttribute('href'));
          }

          var mark = 0;

          if (el) {
            mark = _TotalOffsetTop(el) - _this18.tabs_row.clientHeight - _TotalOffsetTop(_this18.tabs_row) - 180; // target.dataset.mark = mark;
          }

          if (el && mark < 1) {
            _this18.active_tab = target;
          }
        });

        if (this.active_tab) {
          this.active_tab.classList.add('active'); // this.active_tab.scrollIntoView({behavior: "smooth"});
        }
      },
      _tab_click: function _tab_click(event) {
        var target = event.currentTarget;

        var el = this._getTarget(target.getAttribute('href'));

        if (this.container.querySelector('.mobile-menu-container')) {
          this.container.querySelector('.mobile-menu-container').classList.add('hidden');
        }

        if (el) {
          window.scrollTo({
            behavior: 'smooth',
            top: _TotalOffsetTop(el) - this.tabs_row.clientHeight - 100
          });
          event.preventDefault(); // target.classList.add('active');
        }
      },
      _getTarget: function _getTarget(selector) {
        if (!selector) {
          return null;
        }

        var el = null;

        try {
          el = this.container.querySelector(selector);
        } catch (error) {
          console.log(error);
        }

        return el;
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('logo-section', {
      onLoad: function onLoad() {
        this._setupGallery();
      },
      onUnload: function onUnload() {
        this._destroyGallery();
      },
      _setupGallery: function _setupGallery(callback) {
        var swiper_options_1 = {
          autoplay: {
            delay: 2500,
            disableOnInteraction: false
          },
          pagination: {
            el: this.container.querySelector('.swiper-pagination'),
            dynamicBullets: true,
            clickable: true
          },
          breakpoints: {
            200: {
              loop: true,
              direction: 'horizontal',
              slidesPerView: 2,
              noSwiping: true,
              spaceBetween: 20
            },
            640: {
              loop: true,
              direction: 'horizontal',
              slidesPerView: 3,
              noSwiping: true,
              spaceBetween: 30
            },
            768: {
              slidesPerView: 5,
              spaceBetween: 0,
              noSwiping: false,
              allowSlidePrev: false,
              allowSlideNext: false
            }
          }
        };

        if (this.container.querySelector('.featured_logo_slider')) {
          var slider = this.container.querySelector('.featured_logo_slider');
          this.p_slider = new Swiper(slider, swiper_options_1);

          if (typeof callback == 'function') {
            callback();
          }
        }
      },
      _destroyGallery: function _destroyGallery() {
        if (this.p_slider && typeof this.p_slider.destroy == 'function') {
          this.p_slider.destroy();
        }
      }
    });
    
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('hero-section', {
      onLoad: function onLoad() {
        var self = this;
        setTimeout(function () {
          self._setupGallery();
        }, 200);
      },
      onUnload: function onUnload() {// this._destroyGallery();
      },
      _setupGallery: function _setupGallery(callback) {
        var swiper_options_1 = {
          slidesPerView: 1,
          resizeEvent: true,
          autoplay: {
            delay: 6000
          },
          navigation: {
            nextEl: this.container.querySelector('.swiper-button-next'),
            prevEl: this.container.querySelector('.swiper-button-prev')
          }
        };

        if (this.container.querySelector('.hero-banner-swiper')) {
          var slider = this.container.querySelector('.hero-banner-swiper');
          this.p_slider = new Swiper(slider, swiper_options_1); // if (typeof callback == 'function') {
          //   callback();
          // }
        }
      },
      _destroyGallery: function _destroyGallery() {
        if (this.p_slider && typeof this.p_slider.destroy == 'function') {
          this.p_slider.destroy();
        }
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('instagram-slider', {
      onLoad: function onLoad() {
        this.container.addEventListener('click', this._toggleVideoPopup.bind(this));
        this.container.querySelector(".play-pause-btn").addEventListener('click', this._toggleVideo.bind(this));
        this.video = this.container.querySelector(".video-box");
        this.video.addEventListener('click', this._triggerClick.bind(this));
        this.muteBtn = this.container.querySelector(".custom-mute"); // this.video.muted = true;

        this.container.querySelector('#mute-video').addEventListener('click', this._toggleMute.bind(this));
        this.container.querySelector('.close-modal').addEventListener('click', this._closeModal.bind(this));

        this._setupGallery(function () {}.bind(this));
      },
      onUnload: function onUnload() {
        this._destroyGallery();
      },
      _closeModal: function _closeModal(event) {
        event.preventDefault();
        this.video.pause;
        this.video.setAttribute('src', '');
        this.container.querySelector('.video-popup').classList.toggle('hidden');
        this.container.querySelector('.video-popup').classList.toggle('show');
        this.container.querySelector('.play-pause-btn').classList.remove('play-pause-hide');
      },
      _toggleMute: function _toggleMute(event) {
        event.preventDefault();

        if (this.muteBtn.muted == true) {
          this.muteBtn.muted = false;
        } else {
          this.muteBtn.muted = true;
        }

        this.container.querySelector("#mute-video").classList.toggle("show-volume-btn");
      },
      _triggerClick: function _triggerClick(event) {
        event.preventDefault();
        var btn = this.container.querySelector(".play-pause-btn");
        btn && btn.dispatchEvent(new Event('click'));
      },
      _playPause: function _playPause(event) {
        if (this.video.paused) {
          this.video.classList.add("custom-play-icon");
          this.video.play();
        } else {
          this.video.pause();
          this.video.classList.remove("custom-play-icon");
        }
      },
      _toggleVideo: function _toggleVideo(event) {
        event.preventDefault();
        var target = event.currentTarget;
        target.classList.toggle('play-pause-hide');

        if (this.video.paused) {
          this.video.classList.add("custom-play-icon");
          this.video.play();
        } else {
          this.video.pause();
          this.video.classList.remove("custom-play-icon");
        }
      },
      _toggleVideoPopup: function _toggleVideoPopup(event) {
        var target = event.target;

        if (target.classList.contains('.has--video')) {
          event.preventDefault();
          var video_link = target.getAttribute('data-video');
          var video_tag = this.container.querySelector('.video-box');
          video_tag.setAttribute('src', video_link);
          this.container.querySelector('.video-popup').classList.toggle('hidden');
          this.container.querySelector('.video-popup').classList.toggle('show');
        } else if (target.closest('.has--video')) {
          event.preventDefault();
          var current_link = target.closest('.has--video').getAttribute('data-video');

          var _video_tag = this.container.querySelector('.video-box');

          _video_tag.setAttribute('src', current_link);

          this.container.querySelector('.video-popup').classList.toggle('hidden');
          this.container.querySelector('.video-popup').classList.toggle('show');
        }
      },
      _setupGallery: function _setupGallery(callback) {
        var swiper_options_1 = {
          slidesPerView: 4,
          slidesPerGroup: 1,
          spaceBetween: 20,
          loop: true,
          centeredSlides: true,
          threshold: 9,
          pagination: {
            el: this.container.querySelector('.swiper-pagination'),
            clickable: true,
            renderBullet: function renderBullet(index, className) {
              return '<span class="' + className + ' ' + className + '-' + index + '">' + '</span>';
            } //   dynamicBullets: true,
            // dynamicMainBullets: 5

          },
          navigation: {
            nextEl: this.container.querySelector('.swiper-button-next'),
            prevEl: this.container.querySelector('.swiper-button-prev')
          },
          breakpoints: {
            200: {
              slidesPerView: 1.5,
              spaceBetween: 20
            },
            640: {
              slidesPerGroup: 1,
              slidesPerView: 2.5,
              spaceBetween: 30
            },
            768: {
              slidesPerView: 3.5,
              spaceBetween: 30
            },
            1280: {
              slidesPerView: 4.1,
              spaceBetween: 30
            },
            1536: {
              slidesPerGroup: 2,
              slidesPerView: 4.1,
              spaceBetween: 45
            } // 1650: {
            //     slidesPerView: 4,
            //     spaceBetween: 45,
            // }

          }
        };
        var slider = this.container.querySelector('.home-instagram-slider');
        this.p_slider = new Swiper(slider, swiper_options_1);

        if (typeof callback == 'function') {
          callback();
        }
      },
      _destroyGallery: function _destroyGallery() {
        if (this.p_slider && typeof this.p_slider.destroy == 'function') {
          this.p_slider.destroy();
        }
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('zen-team', {
      onLoad: function onLoad() {
        this._setupGallery(function () {
          this.gotoIndex();
        }.bind(this));
      },
      gotoIndex: function gotoIndex(){
        console.log("init 1")
        this.galleryTop.on("init", function(){
            console.log("init 2")
          })
      },
      onUnload: function onUnload() {
        this._destroyGallery();
      },
      _setupGallery: function _setupGallery(callback) {
        var _swiper_options_thumb;

        var swiper_options = {
          spaceBetween: 10,
          slidesPerView: 1,
          // autoHeight: true,
          threshold: 3,
          loop: true,
          pagination: {
            el: this.container.querySelector('.swiper-pagination'),
            type: "fraction"
          },
          navigation: {
            nextEl: this.container.querySelector('.swiper-button-next'),
            prevEl: this.container.querySelector('.swiper-button-prev')
          },
          thumbs: {
            swiper: galleryThumbs
          },
          runCallbacksOnInit: true,
          on: {
            slideChange: function () {
              //console.log(this.container.querySelector('.swiper-slide-active').getAttribute('data-slug'))
              //console.log(document.querySelector('.swiper-slide-active').getAttribute('data-slug'));
            },
          },
        };
        var gallery = this.container.querySelector('.team_content_swiper');
        var galleryTop = new Swiper(gallery, swiper_options); // var galleryThumbs = new Swiper( this.container.querySelector('.gallery-thumbs.product-slider-thumbs'), swiper_options_thumb );

        var swiper_options_thumb = (_swiper_options_thumb = {
          spaceBetween: 30
        }, _defineProperty(_swiper_options_thumb, "spaceBetween", 1), _defineProperty(_swiper_options_thumb, "roundLengths", true), _defineProperty(_swiper_options_thumb, "loopAdditionalSlides", 30), _defineProperty(_swiper_options_thumb, "loop", true), _defineProperty(_swiper_options_thumb, "pagination", {
          el: this.container.querySelector('.swiper-pagination'),
          type: "fraction"
        }), _defineProperty(_swiper_options_thumb, "navigation", {
          nextEl: this.container.querySelector('.swiper-button-next'),
          prevEl: this.container.querySelector('.swiper-button-prev')
        }), _defineProperty(_swiper_options_thumb, "thumbs", {
          swiper: galleryTop
        }), _defineProperty(_swiper_options_thumb, "breakpoints", {
          200: {
            slidesPerView: 2,
            spaceBetween: 30,
            centeredSlides: true
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 30,
            centeredSlides: true
          },
          768: {
            slidesPerView: 3.3,
            spaceBetween: 0,
            centeredSlides: false
          },
          1280: {
            slidesPerView: 3.5,
            spaceBetween: 0,
            centeredSlides: false
          },
          1536: {
            slidesPerView: 3.9,
            spaceBetween: 0,
            centeredSlides: false
          }
        }), _swiper_options_thumb); // var activeSlide = gallery.querySelector('.swiper-slide.active');
        // if (activeSlide) {
        //   swiper_options.initialSlide = activeSlide.dataset.index || 0;
        // }

        galleryTop.on('slideChangeTransitionEnd', function () {
          var ds = document.querySelector('.swiper-slide-active.team-sl').getAttribute('data-slug');
          history.pushState({
              id: 'about-me',
              source: 'web'
          }, 'About me', "/pages/meet-our-nutritionist-and-advisors?m="+ds+"#teams");
        });

        this.galleryTop = galleryTop;
        var galleryThumbs = new Swiper(this.container.querySelector('.mySwiper2'), swiper_options_thumb);
        this.galleryThumbs = galleryThumbs;

        if (typeof callback == 'function') {
          callback();
        }

        console.log('swiper initialized');
        console.log(window.location.search);
        let queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        let sgi = urlParams.get('m');
        if(sgi){
          let swipperIndex = document.querySelector("div[data-slug='"+sgi+"']").getAttribute("data-swiper-slide-index");
          console.log(swipperIndex);
          galleryTop.slideTo(swipperIndex);
          galleryThumbs.slideTo(swipperIndex);
        }
        

      },
      _destroyGallery: function _destroyGallery() {
        if (this.galleryThumbs && typeof this.galleryThumbs.destroy == 'function') {
          this.galleryThumbs.destroy();
        }

        if (this.galleryTop && typeof this.galleryTop.destroy == 'function') {
          this.galleryTop.destroy();
        }
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('reviews-section', {
      onLoad: function onLoad() {
        if (this.container.querySelector('.go-to-review')) {
          this.container.querySelector('.go-to-review').addEventListener('click', this._scrollToReviews.bind(this));
        }
      },
      _scrollToReviews: function _scrollToReviews(event) {
        event.preventDefault();
        var target = event.currentTarget;
        var element = target.getAttribute('href');
        var reviews_section = document.querySelector(element);
        reviews_section.scrollIntoView({
          behavior: "smooth"
        });
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('product-slider', {
      onLoad: function onLoad() {
        var _this19 = this;

        this._setupGallery(function () {}.bind(this));

        if (this.container.querySelectorAll('.btn-add-to-cart')) {
          this.container.querySelectorAll('.btn-add-to-cart').forEach(function (el) {
            return el.addEventListener('click', _this19._attachEvent.bind(_this19));
          });
        }
      },
      onUnload: function onUnload() {
        this._destroyGallery();
      },
      _attachEvent: function _attachEvent(event) {
        event.preventDefault();
        var btn = event.currentTarget;
        var form = btn.closest('.shopify-product-form');

        if (form) {
          btn.disabled = true;
          _shopify_theme_cart__WEBPACK_IMPORTED_MODULE_3__.addItemFromForm(form).then(function (item) {})["catch"](function (error) {
            console.log('A problem occured adding to cart');
          })["finally"](function () {
            btn.classList.remove('adding-to-cart');
            btn.disabled = false;

            if (document.querySelector('.btn-cart-drawer')) {
              window.Shopify.theme.CartDrawer.updateCart(true);
            } else {
              window.location = window.routes.cart_url;
            }
          });
        }
      },
      _setupGallery: function _setupGallery(callback) {
        var swiper_options_1 = {
          slidesPerView: 4,
          spaceBetween: 20,
          loop: true,
          preventClicks: true,
          preventClicksPropagation: true,
          // pagination: {
          //     el: this.container.querySelector('.swiper-pagination'),
          //     clickable: true,
          // },
          navigation: {
            nextEl: this.container.querySelector('.swiper-button-next') // prevEl: this.container.querySelector('.swiper-button-prev'),

          },
          breakpoints: {
            200: {
              slidesPerView: 1,
              spaceBetween: 20
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 30
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 30
            },
            1280: {
              slidesPerView: 3,
              spaceBetween: 30
            },
            1536: {
              slidesPerView: 4,
              spaceBetween: 40
            },
            1650: {
              slidesPerView: 4,
              spaceBetween: 55
            }
          }
        };
        var slider = this.container.querySelector('.home-collection-slider');
        this.p_slider = new Swiper(slider, swiper_options_1);

        if (typeof callback == 'function') {
          callback();
        }
      },
      _destroyGallery: function _destroyGallery() {
        if (this.p_slider && typeof this.p_slider.destroy == 'function') {
          this.p_slider.destroy();
        }
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('cart-section', {
      onLoad: function onLoad() {
        var _this20 = this;

        this.attachListeners();

        this._setupForm();

        this._setupSlider();

        this.ajax_timer = null;
        this.cart = this.container.querySelector('.cart-container');
        document.addEventListener("zrx-discount-applied", function (e) {
          _this20.container.querySelector('.savings-wrapper').classList.remove('hidden');

          _this20.container.querySelector('.savings-wrapper .savings').innerHTML = Currency.formatMoney(e.detail * 100, window.Zoorix.moneyFormat);
        });
      },
      attachListeners: function attachListeners() {
        var _this21 = this;

        this.container.querySelectorAll('.qty-picker input').forEach(function (el) {
          return el.addEventListener('change', _this21._onQuantityChange.bind(_this21));
        });
        this.container.querySelectorAll('.delete-btn').forEach(function (el) {
          return el.addEventListener('click', _this21._deleteItem.bind(_this21));
        });
      },
      _setupForm: function _setupForm() {
        var _this22 = this;

        this.container.addEventListener('click', function (event) {
          var btn = event.target;

          if (btn.classList.contains('add-product-btn') || btn.closest('.add-product-btn')) {
            event.preventDefault();
            var form = btn.closest('[action="/cart/add"]');

            if (form) {
              // btn.classList.add('adding-to-cart');
              // btn.disabled = true;
              _shopify_theme_cart__WEBPACK_IMPORTED_MODULE_3__.addItemFromForm(form).then(function (item) {})["catch"](function (error) {
                console.log('A problem occured adding to cart');
              })["finally"](function () {
                // btn.classList.remove('adding-to-cart');
                // btn.disabled = false;
                _this22._updateCart();
              });
            }
          }
        });
      },
      _setupSlider: function _setupSlider(callback) {
        var swiper_options_thumb = {
          autoHeight: true,
          slidesPerView: 1,
          initialSlide: 1,
          centeredSlides: true,
          resizeEvent: true,
          pagination: {
            el: ".swiper-pagination.upsell",
            clickable: true
          }
        };

        if (document.querySelector('.cartproduct_slider')) {
          var upsells_slider = new Swiper(this.container.querySelector('.cartproduct_slider'), swiper_options_thumb);
        }

        if (typeof callback == 'function') {
          callback();
        }
      },
      _onFormSubmit: function _onFormSubmit(event) {
        var _this23 = this;

        event.preventDefault(); // var form = this

        var form = event.currentTarget; // var btn = form.querySelector('[type="submit"]');
        // btn.classList.add('adding-to-cart');

        event.preventDefault();
        _shopify_theme_cart__WEBPACK_IMPORTED_MODULE_3__.addItemFromForm(form).then(function (item) {})["catch"](function (error) {
          console.log('A problem occured adding to cart');
        })["finally"](function () {
          _this23._updateCart();
        });
      },
      _onQuantityChange: function _onQuantityChange(event) {
        var _this24 = this;

        var input = event.currentTarget;
        var quantity = input.value * 1;
        input.closest('.tr').querySelectorAll('.qty-picker input').forEach(function (el) {
          return el.value = input.value;
        });
        var btns = input.closest('.tr').querySelectorAll('.qty-picker button');
        var key = input.dataset.key;

        if (key && !isNaN(quantity)) {
          clearTimeout(this.ajax_timer);
          this.ajax_timer = setTimeout(function () {
            btns.forEach(function (el) {
              return el.disabled = true;
            });
            _shopify_theme_cart__WEBPACK_IMPORTED_MODULE_3__.updateItem(key, {
              quantity: quantity
            }).then(function (state) {
              // var item = state.items.find(item => item.key === key);
              // console.log(`The item with key '${key}' now has quantity ${item.quantity}`);
              _this24._updateCart();
            })["catch"](function (error) {
              console.log('A problem occured adding to cart');
            })["finally"](function () {
              btns.forEach(function (el) {
                return el.disabled = false;
              });
            });
          }, 400);
        }
      },
      _deleteItem: function _deleteItem(event) {
        var _this25 = this;

        var target = event.currentTarget;
        var key = target.dataset.key;
        _shopify_theme_cart__WEBPACK_IMPORTED_MODULE_3__.removeItem(key).then(function (state) {
          _this25._updateCart(); // window.Shopify.theme.CartDrawer.updateCart();

        });
        event.preventDefault();
      },
      _updateCart: function _updateCart() {
        var _this26 = this;

        var cartUrl = window.routes.cart_url.concat("?view=ajax");
        fetch(cartUrl).then(function (response) {
          return response.text();
        }).then(function (cart) {
          if (cart.trim() === '') {
            return;
          }

          var tempDiv = document.createElement("div");
          tempDiv.innerHTML = cart;
          var cart = tempDiv.querySelector('.shopify-section .cart-container');

          if (_this26.cart) {
            // var cart_total_qty = cart.querySelector('.cart__qty').innerHTML;
            // document.querySelector('.noti-class').innerHTML = cart_total_qty;
            _this26.cart.innerHTML = cart.innerHTML;

            _this26.attachListeners();

            _this26._setupForm();

            _this26._setupSlider();

            window.Shopify.theme.CartDrawer.updateCart();
            new QuantityPicker(_this26.cart);
          }
        });
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('hero-section', document.querySelector('[data-section-type="hero-section"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('header-section', document.querySelector('[data-section-type="header-section"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('product-section', document.querySelector('[data-section-type="product-section"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('collection-section', document.querySelector('[data-section-type="collection-section"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('product-tabs-section', document.querySelector('[data-section-type="product-tabs-section"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('blog-section', document.querySelector('[data-section-type="blog-section"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('white-paper-section', document.querySelector('[data-section-type="white-paper-section"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('article-section', document.querySelector('[data-section-type="article-section"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('article-details-page', document.querySelector('[data-section-type="article-details-page"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('product-slider', document.querySelectorAll('[data-section-type="product-slider"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('logo-section', document.querySelector('[data-section-type="logo-section"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('instagram-slider', document.querySelector('[data-section-type="instagram-slider"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('zen-team', document.querySelector('[data-section-type="zen-team"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('reviews-section', document.querySelector('[data-section-type="reviews-section"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('cart-section', document.querySelector('[data-section-type="cart-section"]'));

    (function () {
      window.WOW && new WOW().init();
    })();

    (function () {
      document.querySelectorAll('main iframe[src*="youtube.com"], main iframe[src*="youtu.be"]').forEach(function (iframe) {
        if (!iframe.closest('.videoWrapper, .fr-video')) {
          var wrapper = document.createElement('div');
          wrapper.classList.add('videoWrapper');
          wrapper.appendChild(iframe.cloneNode(true));
          iframe.replaceWith(wrapper);
        }
      });
      var links = document.links;

      for (var i = 0, linksLength = links.length; i < linksLength; i++) {
        if (links[i].hostname !== "" && links[i].hostname !== window.location.hostname) {
          links[i].target = '_blank';
          links[i].rel = 'noreferrer noopener';
        }
      }
    })();
  };

  var docReady = function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
      // call on next available tick
      setTimeout(fn, 1);
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  };

  docReady(function () {
    if ('fetch' in window && 'assign' in Object) {
      bootTheme();
    } else {
      var scriptEl = document.createElement('script');
      scriptEl.src = '//cdn.polyfill.io/v3/polyfill.min.js?unknown=polyfill&features=fetch,Element.prototype.closest,Element.prototype.matches,Element.prototype.remove,Element.prototype.classList,Array.prototype.includes,String.prototype.includes,Object.assign,CustomEvent,URL,DOMTokenList';
      scriptEl.async = false;

      scriptEl.onload = function () {
        bootTheme();
      };

      document.head.appendChild(scriptEl);
    }
  });
})();
})();

/******/ })()
;